(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree41b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree41b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kOgzt", function(module, exports) {
$parcel$export(module.exports, "b64_decode", () => (parcelRequire("77crt")).b64_decode);
$parcel$export(module.exports, "getColorHexValue", () => (parcelRequire("3IaSv")).getColorHexValue);
$parcel$export(module.exports, "getAllCookies", () => (parcelRequire("ceOOn")).getAllCookies);
$parcel$export(module.exports, "elementReady", () => (parcelRequire("a3TA1")).elementReady);
$parcel$export(module.exports, "addWindowResizeEvent", () => (parcelRequire("6oLIz")).addWindowResizeEvent);
$parcel$export(module.exports, "addWindowScrollEvent", () => (parcelRequire("6oLIz")).addWindowScrollEvent);
$parcel$export(module.exports, "getReCAPTCHAResponse", () => (parcelRequire("isKkJ")).getReCAPTCHAResponse);
$parcel$export(module.exports, "slideDown", () => (parcelRequire("h30hJ")).slideDown);
$parcel$export(module.exports, "slideUp", () => (parcelRequire("h30hJ")).slideUp);
$parcel$export(module.exports, "scrollToElement", () => (parcelRequire("jWfAU")).scrollToElement);
$parcel$export(module.exports, "getThemeData", () => (parcelRequire("6sEQA")).getThemeData);
$parcel$export(module.exports, "waitForElement", () => (parcelRequire("hxRak")).waitForElement);
parcelRequire("77crt");
parcelRequire("3IaSv");
parcelRequire("ceOOn");
parcelRequire("a3TA1");
parcelRequire("6oLIz");
parcelRequire("isKkJ");
parcelRequire("h30hJ");
parcelRequire("jWfAU");
parcelRequire("6sEQA");
parcelRequire("hxRak");

});
parcelRegister("77crt", function(module, exports) {

$parcel$export(module.exports, "b64_decode", () => $52e2d69231a1aae4$export$bf9d481ba07b53f9);
const $52e2d69231a1aae4$export$3c2a198a9c1ae5f3 = (string)=>{
    return window.btoa(unescape(encodeURIComponent(string)));
};
const $52e2d69231a1aae4$export$bf9d481ba07b53f9 = (string)=>{
    return decodeURIComponent(escape(window.atob(string)));
};

});

parcelRegister("3IaSv", function(module, exports) {

$parcel$export(module.exports, "getColorHexValue", () => $2b3deb4eff4b3150$export$be9603b40fb67b4a);

var $b8TNY = parcelRequire("b8TNY");
const $2b3deb4eff4b3150$export$be9603b40fb67b4a = (id, opacity = 1, useTransparency = false)=>{
    const bodyColorValue = getComputedStyle(document.body).getPropertyValue(`--color-body`);
    const baseColorValue = getComputedStyle(document.body).getPropertyValue(`--color-${id}`);
    if (useTransparency) return (0, $b8TNY.default)(baseColorValue).alpha(opacity).hex();
    else return (0, $b8TNY.default)(baseColorValue).mix(bodyColorValue, 1 - opacity).hex();
};

});
parcelRegister("b8TNY", function(module, exports) {

$parcel$export(module.exports, "default", () => $81cbbacd84e74401$export$2e2bcd8739ae039);
// feel free to comment out anything to rollup
// a smaller chroma.js bundle

var $gaK1V = parcelRequire("gaK1V");
parcelRequire("cF22K");
parcelRequire("iygXn");
parcelRequire("QEjK4");
parcelRequire("kytU9");
parcelRequire("kn0Pa");
parcelRequire("hDPZe");
parcelRequire("eDzBg");
parcelRequire("7pAyc");
parcelRequire("kXega");
parcelRequire("8P76D");
parcelRequire("bEZjX");
parcelRequire("jywIV");
parcelRequire("4Zhp6");
parcelRequire("kMTGA");
parcelRequire("dkzY3");
parcelRequire("gac9F");
parcelRequire("fWmFX");
parcelRequire("3s82t");
parcelRequire("75dqB");
parcelRequire("2ISBM");
parcelRequire("52gBS");
parcelRequire("3wKag");

var $8UmTp = parcelRequire("8UmTp");

var $9u72g = parcelRequire("9u72g");

var $hKhjA = parcelRequire("hKhjA");

var $jpCQy = parcelRequire("jpCQy");

var $dvq8W = parcelRequire("dvq8W");

var $eIGWI = parcelRequire("eIGWI");

var $4ZQS0 = parcelRequire("4ZQS0");

var $cgHIr = parcelRequire("cgHIr");

var $5BDZu = parcelRequire("5BDZu");

var $iM4ga = parcelRequire("iM4ga");

var $xkLDw = parcelRequire("xkLDw");

var $iB6ta = parcelRequire("iB6ta");

var $dID0y = parcelRequire("dID0y");

var $lT4NS = parcelRequire("lT4NS");

var $1vtEw = parcelRequire("1vtEw");

var $2LSBy = parcelRequire("2LSBy");

var $6Sny4 = parcelRequire("6Sny4");

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("7hd9c");
parcelRequire("cIiSk");
parcelRequire("kBR14");
parcelRequire("hskHC");
parcelRequire("bmZFS");
parcelRequire("2yZD4");
parcelRequire("fbI2I");
parcelRequire("7Z9E2");
parcelRequire("996dd");
parcelRequire("getAx");
parcelRequire("eSrDz");
parcelRequire("ayOPU");
parcelRequire("i89Hq");
parcelRequire("j6weT");
parcelRequire("35MHU");
Object.assign((0, $gaK1V.default), {
    analyze: $cgHIr.analyze,
    average: $8UmTp.default,
    bezier: $9u72g.default,
    blend: $hKhjA.default,
    brewer: $6Sny4.default,
    Color: $e7KSJ.default,
    colors: $2LSBy.default,
    contrast: $5BDZu.default,
    contrastAPCA: $iM4ga.default,
    cubehelix: $jpCQy.default,
    deltaE: $xkLDw.default,
    distance: $iB6ta.default,
    input: $lT4NS.default,
    interpolate: (0, $dvq8W.default),
    limits: $cgHIr.limits,
    mix: $dvq8W.default,
    random: $eIGWI.default,
    scale: $4ZQS0.default,
    scales: $1vtEw.default,
    valid: $dID0y.default
});
var $81cbbacd84e74401$export$2e2bcd8739ae039 = (0, $gaK1V.default);

});
parcelRegister("gaK1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc61491d55326ff6$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");

var $6QlZc = parcelRequire("6QlZc");
const $bc61491d55326ff6$var$chroma = (...args)=>{
    return new (0, $e7KSJ.default)(...args);
};
$bc61491d55326ff6$var$chroma.version = (0, $6QlZc.version);
var $bc61491d55326ff6$export$2e2bcd8739ae039 = $bc61491d55326ff6$var$chroma;

});
parcelRegister("e7KSJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a48615e4fc00386b$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $8TO5X = parcelRequire("8TO5X");
var $7ElX1 = parcelRequire("7ElX1");
var $hMEmV = parcelRequire("hMEmV");

var $lT4NS = parcelRequire("lT4NS");
class $a48615e4fc00386b$var$Color {
    constructor(...args){
        const me = this;
        if ((0, $hMEmV.default)(args[0]) === 'object' && args[0].constructor && args[0].constructor === this.constructor) // the argument is already a Color instance
        return args[0];
        // last argument could be the mode
        let mode = (0, $7ElX1.default)(args);
        let autodetect = false;
        if (!mode) {
            autodetect = true;
            if (!(0, $lT4NS.default).sorted) {
                (0, $lT4NS.default).autodetect = (0, $lT4NS.default).autodetect.sort((a, b)=>b.p - a.p);
                (0, $lT4NS.default).sorted = true;
            }
            // auto-detect format
            for (let chk of (0, $lT4NS.default).autodetect){
                mode = chk.test(...args);
                if (mode) break;
            }
        }
        if ((0, $lT4NS.default).format[mode]) {
            const rgb = (0, $lT4NS.default).format[mode].apply(null, autodetect ? args : args.slice(0, -1));
            me._rgb = (0, $8TO5X.default)(rgb);
        } else throw new Error('unknown format: ' + args);
        // add alpha channel
        if (me._rgb.length === 3) me._rgb.push(1);
    }
    toString() {
        if ((0, $hMEmV.default)(this.hex) == 'function') return this.hex();
        return `[${this._rgb.join(',')}]`;
    }
}
var $a48615e4fc00386b$export$2e2bcd8739ae039 = $a48615e4fc00386b$var$Color;

});
parcelRegister("i4gda", function(module, exports) {

$parcel$export(module.exports, "min", () => $0364fc9895a99d2c$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $0364fc9895a99d2c$export$8960430cfd85939f);
$parcel$export(module.exports, "rnd2", () => $0364fc9895a99d2c$export$c6d486233e29f7d1);
$parcel$export(module.exports, "rnd3", () => $0364fc9895a99d2c$export$6ed426801b9660b8);
$parcel$export(module.exports, "TWOPI", () => $0364fc9895a99d2c$export$af54f71c879f5ba9);
$parcel$export(module.exports, "PITHIRD", () => $0364fc9895a99d2c$export$e734282486210baf);
$parcel$export(module.exports, "DEG2RAD", () => $0364fc9895a99d2c$export$460c4029b1a54a2e);
$parcel$export(module.exports, "RAD2DEG", () => $0364fc9895a99d2c$export$914076c8150813e5);
$parcel$export(module.exports, "reverse3", () => $0364fc9895a99d2c$export$d0e1128e52417073);
$parcel$export(module.exports, "clip_rgb", () => (parcelRequire("8TO5X")).default);
$parcel$export(module.exports, "limit", () => (parcelRequire("gb2Ug")).default);
$parcel$export(module.exports, "type", () => (parcelRequire("hMEmV")).default);
$parcel$export(module.exports, "unpack", () => (parcelRequire("43ZPL")).default);
$parcel$export(module.exports, "last", () => (parcelRequire("7ElX1")).default);

var $8TO5X = parcelRequire("8TO5X");

var $gb2Ug = parcelRequire("gb2Ug");

var $hMEmV = parcelRequire("hMEmV");

var $43ZPL = parcelRequire("43ZPL");

var $7ElX1 = parcelRequire("7ElX1");
const { PI: $0364fc9895a99d2c$export$6b5c1ceb16d01dc3, min: $0364fc9895a99d2c$export$96ec731ed4dcb222, max: $0364fc9895a99d2c$export$8960430cfd85939f } = Math;
const $0364fc9895a99d2c$export$c6d486233e29f7d1 = (a)=>Math.round(a * 100) / 100;
const $0364fc9895a99d2c$export$6ed426801b9660b8 = (a)=>Math.round(a * 100) / 100;
const $0364fc9895a99d2c$export$af54f71c879f5ba9 = $0364fc9895a99d2c$export$6b5c1ceb16d01dc3 * 2;
const $0364fc9895a99d2c$export$e734282486210baf = $0364fc9895a99d2c$export$6b5c1ceb16d01dc3 / 3;
const $0364fc9895a99d2c$export$460c4029b1a54a2e = $0364fc9895a99d2c$export$6b5c1ceb16d01dc3 / 180;
const $0364fc9895a99d2c$export$914076c8150813e5 = 180 / $0364fc9895a99d2c$export$6b5c1ceb16d01dc3;
/**
 * Reverse the first three elements of an array
 *
 * @param {any[]} arr
 * @returns {any[]}
 */ function $0364fc9895a99d2c$export$d0e1128e52417073(arr) {
    return [
        ...arr.slice(0, 3).reverse(),
        ...arr.slice(3)
    ];
}

});
parcelRegister("8TO5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $67aa519ab0061f26$export$2e2bcd8739ae039);

var $gb2Ug = parcelRequire("gb2Ug");
var $67aa519ab0061f26$export$2e2bcd8739ae039 = (rgb)=>{
    rgb._clipped = false;
    rgb._unclipped = rgb.slice(0);
    for(let i = 0; i <= 3; i++){
        if (i < 3) {
            if (rgb[i] < 0 || rgb[i] > 255) rgb._clipped = true;
            rgb[i] = (0, $gb2Ug.default)(rgb[i], 0, 255);
        } else if (i === 3) rgb[i] = (0, $gb2Ug.default)(rgb[i], 0, 1);
    }
    return rgb;
};

});
parcelRegister("gb2Ug", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc6fed995261efd6$export$2e2bcd8739ae039);
const { min: $bc6fed995261efd6$var$min, max: $bc6fed995261efd6$var$max } = Math;
var $bc6fed995261efd6$export$2e2bcd8739ae039 = (x, low = 0, high = 1)=>{
    return $bc6fed995261efd6$var$min($bc6fed995261efd6$var$max(low, x), high);
};

});


parcelRegister("hMEmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf263bc72046187c$export$2e2bcd8739ae039);
// ported from jQuery's $.type
const $cf263bc72046187c$var$classToType = {};
for (let name of [
    'Boolean',
    'Number',
    'String',
    'Function',
    'Array',
    'Date',
    'RegExp',
    'Undefined',
    'Null'
])$cf263bc72046187c$var$classToType[`[object ${name}]`] = name.toLowerCase();
function $cf263bc72046187c$export$2e2bcd8739ae039(obj) {
    return $cf263bc72046187c$var$classToType[Object.prototype.toString.call(obj)] || 'object';
}

});

parcelRegister("43ZPL", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f57682b2b3fd0b6$export$2e2bcd8739ae039);

var $hMEmV = parcelRequire("hMEmV");
var $2f57682b2b3fd0b6$export$2e2bcd8739ae039 = (args, keyOrder = null)=>{
    // if called with more than 3 arguments, we return the arguments
    if (args.length >= 3) return Array.prototype.slice.call(args);
    // with less than 3 args we check if first arg is object
    // and use the keyOrder string to extract and sort properties
    if ((0, $hMEmV.default)(args[0]) == 'object' && keyOrder) return keyOrder.split('').filter((k)=>args[0][k] !== undefined).map((k)=>args[0][k]);
    // otherwise we just return the first argument
    // (which we suppose is an array of args)
    return args[0].slice(0);
};

});

parcelRegister("7ElX1", function(module, exports) {

$parcel$export(module.exports, "default", () => $591d4bdad7401082$export$2e2bcd8739ae039);

var $hMEmV = parcelRequire("hMEmV");
var $591d4bdad7401082$export$2e2bcd8739ae039 = (args)=>{
    if (args.length < 2) return null;
    const l = args.length - 1;
    if ((0, $hMEmV.default)(args[l]) == 'string') return args[l].toLowerCase();
    return null;
};

});


parcelRegister("lT4NS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fef275e9b9623611$export$2e2bcd8739ae039);
var $fef275e9b9623611$export$2e2bcd8739ae039 = {
    format: {},
    autodetect: []
};

});


parcelRegister("6QlZc", function(module, exports) {

$parcel$export(module.exports, "version", () => $4fb8a75d624eee90$export$83d89fbfd8236492);
// this gets updated automatically
const $4fb8a75d624eee90$export$83d89fbfd8236492 = '3.1.2';

});


parcelRegister("cF22K", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $2LSBy = parcelRequire("2LSBy");

var $2BpKe = parcelRequire("2BpKe");

var $eL95G = parcelRequire("eL95G");
(0, $e7KSJ.default).prototype.name = function() {
    const hex = (0, $eL95G.default)(this._rgb, 'rgb');
    for (let n of Object.keys((0, $2LSBy.default))){
        if ((0, $2LSBy.default)[n] === hex) return n.toLowerCase();
    }
    return hex;
};
(0, $lT4NS.default).format.named = (name)=>{
    name = name.toLowerCase();
    if ((0, $2LSBy.default)[name]) return (0, $2BpKe.default)((0, $2LSBy.default)[name]);
    throw new Error('unknown color name: ' + name);
};
(0, $lT4NS.default).autodetect.push({
    p: 5,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $hMEmV.default)(h) === 'string' && (0, $2LSBy.default)[h.toLowerCase()]) return 'named';
    }
});

});
parcelRegister("2LSBy", function(module, exports) {

$parcel$export(module.exports, "default", () => $204a53f04c74292a$export$2e2bcd8739ae039);
/**
	X11 color names

	http://www.w3.org/TR/css3-color/#svg-color
*/ const $204a53f04c74292a$var$w3cx11 = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    laserlemon: '#ffff54',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrod: '#fafad2',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    maroon2: '#7f0000',
    maroon3: '#b03060',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    purple2: '#7f007f',
    purple3: '#a020f0',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
};
var $204a53f04c74292a$export$2e2bcd8739ae039 = $204a53f04c74292a$var$w3cx11;

});

parcelRegister("2BpKe", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e5301da89c3e9c8$export$2e2bcd8739ae039);
const $1e5301da89c3e9c8$var$RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
const $1e5301da89c3e9c8$var$RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;
const $1e5301da89c3e9c8$var$hex2rgb = (hex)=>{
    if (hex.match($1e5301da89c3e9c8$var$RE_HEX)) {
        // remove optional leading #
        if (hex.length === 4 || hex.length === 7) hex = hex.substr(1);
        // expand short-notation to full six-digit
        if (hex.length === 3) {
            hex = hex.split('');
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        const u = parseInt(hex, 16);
        const r = u >> 16;
        const g = u >> 8 & 0xff;
        const b = u & 0xff;
        return [
            r,
            g,
            b,
            1
        ];
    }
    // match rgba hex format, eg #FF000077
    if (hex.match($1e5301da89c3e9c8$var$RE_HEXA)) {
        if (hex.length === 5 || hex.length === 9) // remove optional leading #
        hex = hex.substr(1);
        // expand short-notation to full eight-digit
        if (hex.length === 4) {
            hex = hex.split('');
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
        }
        const u = parseInt(hex, 16);
        const r = u >> 24 & 0xff;
        const g = u >> 16 & 0xff;
        const b = u >> 8 & 0xff;
        const a = Math.round((u & 0xff) / 0xff * 100) / 100;
        return [
            r,
            g,
            b,
            a
        ];
    }
    // we used to check for css colors here
    // if _input.css? and rgb = _input.css hex
    //     return rgb
    throw new Error(`unknown hex color: ${hex}`);
};
var $1e5301da89c3e9c8$export$2e2bcd8739ae039 = $1e5301da89c3e9c8$var$hex2rgb;

});

parcelRegister("eL95G", function(module, exports) {

$parcel$export(module.exports, "default", () => $abec81afd0345325$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $43ZPL = parcelRequire("43ZPL");
const { round: $abec81afd0345325$var$round } = Math;
const $abec81afd0345325$var$rgb2hex = (...args)=>{
    let [r, g, b, a] = (0, $43ZPL.default)(args, 'rgba');
    let mode = (0, $7ElX1.default)(args) || 'auto';
    if (a === undefined) a = 1;
    if (mode === 'auto') mode = a < 1 ? 'rgba' : 'rgb';
    r = $abec81afd0345325$var$round(r);
    g = $abec81afd0345325$var$round(g);
    b = $abec81afd0345325$var$round(b);
    const u = r << 16 | g << 8 | b;
    let str = '000000' + u.toString(16); //#.toUpperCase();
    str = str.substr(str.length - 6);
    let hxa = '0' + $abec81afd0345325$var$round(a * 255).toString(16);
    hxa = hxa.substr(hxa.length - 2);
    switch(mode.toLowerCase()){
        case 'rgba':
            return `#${str}${hxa}`;
        case 'argb':
            return `#${hxa}${str}`;
        default:
            return `#${str}`;
    }
};
var $abec81afd0345325$export$2e2bcd8739ae039 = $abec81afd0345325$var$rgb2hex;

});


parcelRegister("iygXn", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
(0, $e7KSJ.default).prototype.alpha = function(a, mutate = false) {
    if (a !== undefined && (0, $hMEmV.default)(a) === 'number') {
        if (mutate) {
            this._rgb[3] = a;
            return this;
        }
        return new (0, $e7KSJ.default)([
            this._rgb[0],
            this._rgb[1],
            this._rgb[2],
            a
        ], 'rgb');
    }
    return this._rgb[3];
};

});

parcelRegister("QEjK4", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
(0, $e7KSJ.default).prototype.clipped = function() {
    return this._rgb._clipped || false;
};

});

parcelRegister("kytU9", function(module, exports) {
parcelRequire("996dd");

var $e7KSJ = parcelRequire("e7KSJ");

var $8weUB = parcelRequire("8weUB");
(0, $e7KSJ.default).prototype.darken = function(amount = 1) {
    const me = this;
    const lab = me.lab();
    lab[0] -= (0, $8weUB.default).Kn * amount;
    return new (0, $e7KSJ.default)(lab, 'lab').alpha(me.alpha(), true);
};
(0, $e7KSJ.default).prototype.brighten = function(amount = 1) {
    return this.darken(-amount);
};
(0, $e7KSJ.default).prototype.darker = (0, $e7KSJ.default).prototype.darken;
(0, $e7KSJ.default).prototype.brighter = (0, $e7KSJ.default).prototype.brighten;

});
parcelRegister("996dd", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $jenZn = parcelRequire("jenZn");

var $luvnN = parcelRequire("luvnN");

var $8weUB = parcelRequire("8weUB");
(0, $e7KSJ.default).prototype.lab = function() {
    return (0, $luvnN.default)(this._rgb);
};
const $6a89c5f2d5780cd3$export$c83fb8f9027a6338 = (...args)=>new (0, $e7KSJ.default)(...args, 'lab');
Object.assign((0, $gaK1V.default), {
    lab: $6a89c5f2d5780cd3$export$c83fb8f9027a6338,
    getLabWhitePoint: $8weUB.getLabWhitePoint,
    setLabWhitePoint: $8weUB.setLabWhitePoint
});
(0, $lT4NS.default).format.lab = (0, $jenZn.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'lab');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'lab';
    }
});

});
parcelRegister("jenZn", function(module, exports) {

$parcel$export(module.exports, "xyz2rgb", () => $e001eed8d7ff32c4$export$22cbacf088b0f5c6);
$parcel$export(module.exports, "default", () => $e001eed8d7ff32c4$export$2e2bcd8739ae039);

var $8weUB = parcelRequire("8weUB");
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * L* [0..100]
 * a [-100..100]
 * b [-100..100]
 */ const $e001eed8d7ff32c4$var$lab2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'lab');
    const [L, a, b] = args;
    const [x, y, z] = $e001eed8d7ff32c4$var$lab2xyz(L, a, b);
    const [r, g, b_] = $e001eed8d7ff32c4$export$22cbacf088b0f5c6(x, y, z);
    return [
        r,
        g,
        b_,
        args.length > 3 ? args[3] : 1
    ];
};
const $e001eed8d7ff32c4$var$lab2xyz = (L, a, b)=>{
    const { kE: kE, kK: kK, kKE: kKE, Xn: Xn, Yn: Yn, Zn: Zn } = (0, $8weUB.default);
    const fy = (L + 16.0) / 116.0;
    const fx = 0.002 * a + fy;
    const fz = fy - 0.005 * b;
    const fx3 = fx * fx * fx;
    const fz3 = fz * fz * fz;
    const xr = fx3 > kE ? fx3 : (116.0 * fx - 16.0) / kK;
    const yr = L > kKE ? Math.pow((L + 16.0) / 116.0, 3.0) : L / kK;
    const zr = fz3 > kE ? fz3 : (116.0 * fz - 16.0) / kK;
    const x = xr * Xn;
    const y = yr * Yn;
    const z = zr * Zn;
    return [
        x,
        y,
        z
    ];
};
const $e001eed8d7ff32c4$var$compand = (linear)=>{
    /* sRGB */ const sign = Math.sign(linear);
    linear = Math.abs(linear);
    return (linear <= 0.0031308 ? linear * 12.92 : 1.055 * Math.pow(linear, 1.0 / 2.4) - 0.055) * sign;
};
const $e001eed8d7ff32c4$export$22cbacf088b0f5c6 = (x, y, z)=>{
    const { MtxAdaptMa: MtxAdaptMa, MtxAdaptMaI: MtxAdaptMaI, MtxXYZ2RGB: MtxXYZ2RGB, RefWhiteRGB: RefWhiteRGB, Xn: Xn, Yn: Yn, Zn: Zn } = (0, $8weUB.default);
    const As = Xn * MtxAdaptMa.m00 + Yn * MtxAdaptMa.m10 + Zn * MtxAdaptMa.m20;
    const Bs = Xn * MtxAdaptMa.m01 + Yn * MtxAdaptMa.m11 + Zn * MtxAdaptMa.m21;
    const Cs = Xn * MtxAdaptMa.m02 + Yn * MtxAdaptMa.m12 + Zn * MtxAdaptMa.m22;
    const Ad = RefWhiteRGB.X * MtxAdaptMa.m00 + RefWhiteRGB.Y * MtxAdaptMa.m10 + RefWhiteRGB.Z * MtxAdaptMa.m20;
    const Bd = RefWhiteRGB.X * MtxAdaptMa.m01 + RefWhiteRGB.Y * MtxAdaptMa.m11 + RefWhiteRGB.Z * MtxAdaptMa.m21;
    const Cd = RefWhiteRGB.X * MtxAdaptMa.m02 + RefWhiteRGB.Y * MtxAdaptMa.m12 + RefWhiteRGB.Z * MtxAdaptMa.m22;
    const X1 = (x * MtxAdaptMa.m00 + y * MtxAdaptMa.m10 + z * MtxAdaptMa.m20) * (Ad / As);
    const Y1 = (x * MtxAdaptMa.m01 + y * MtxAdaptMa.m11 + z * MtxAdaptMa.m21) * (Bd / Bs);
    const Z1 = (x * MtxAdaptMa.m02 + y * MtxAdaptMa.m12 + z * MtxAdaptMa.m22) * (Cd / Cs);
    const X2 = X1 * MtxAdaptMaI.m00 + Y1 * MtxAdaptMaI.m10 + Z1 * MtxAdaptMaI.m20;
    const Y2 = X1 * MtxAdaptMaI.m01 + Y1 * MtxAdaptMaI.m11 + Z1 * MtxAdaptMaI.m21;
    const Z2 = X1 * MtxAdaptMaI.m02 + Y1 * MtxAdaptMaI.m12 + Z1 * MtxAdaptMaI.m22;
    const r = $e001eed8d7ff32c4$var$compand(X2 * MtxXYZ2RGB.m00 + Y2 * MtxXYZ2RGB.m10 + Z2 * MtxXYZ2RGB.m20);
    const g = $e001eed8d7ff32c4$var$compand(X2 * MtxXYZ2RGB.m01 + Y2 * MtxXYZ2RGB.m11 + Z2 * MtxXYZ2RGB.m21);
    const b = $e001eed8d7ff32c4$var$compand(X2 * MtxXYZ2RGB.m02 + Y2 * MtxXYZ2RGB.m12 + Z2 * MtxXYZ2RGB.m22);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
var $e001eed8d7ff32c4$export$2e2bcd8739ae039 = $e001eed8d7ff32c4$var$lab2rgb;

});
parcelRegister("8weUB", function(module, exports) {

$parcel$export(module.exports, "default", () => $633ce119b108995d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "setLabWhitePoint", () => $633ce119b108995d$export$23f27f4cae67c045);
$parcel$export(module.exports, "getLabWhitePoint", () => $633ce119b108995d$export$922c3afbcbc31cb3);
const $633ce119b108995d$var$labConstants = {
    // Corresponds roughly to RGB brighter/darker
    Kn: 18,
    // D65 standard referent
    labWhitePoint: 'd65',
    Xn: 0.95047,
    Yn: 1,
    Zn: 1.08883,
    t0: 0.137931034,
    t1: 0.206896552,
    t2: 0.12841855,
    t3: 0.008856452,
    kE: 216.0 / 24389.0,
    kKE: 8.0,
    kK: 24389.0 / 27.0,
    RefWhiteRGB: {
        // sRGB
        X: 0.95047,
        Y: 1,
        Z: 1.08883
    },
    MtxRGB2XYZ: {
        m00: 0.4124564390896922,
        m01: 0.21267285140562253,
        m02: 0.0193338955823293,
        m10: 0.357576077643909,
        m11: 0.715152155287818,
        m12: 0.11919202588130297,
        m20: 0.18043748326639894,
        m21: 0.07217499330655958,
        m22: 0.9503040785363679
    },
    MtxXYZ2RGB: {
        m00: 3.2404541621141045,
        m01: -0.9692660305051868,
        m02: 0.055643430959114726,
        m10: -1.5371385127977166,
        m11: 1.8760108454466942,
        m12: -0.2040259135167538,
        m20: -0.498531409556016,
        m21: 0.041556017530349834,
        m22: 1.0572251882231791
    },
    // used in rgb2xyz
    As: 0.9414285350000001,
    Bs: 1.040417467,
    Cs: 1.089532651,
    MtxAdaptMa: {
        m00: 0.8951,
        m01: -0.7502,
        m02: 0.0389,
        m10: 0.2664,
        m11: 1.7135,
        m12: -0.0685,
        m20: -0.1614,
        m21: 0.0367,
        m22: 1.0296
    },
    MtxAdaptMaI: {
        m00: 0.9869929054667123,
        m01: 0.43230526972339456,
        m02: -0.008528664575177328,
        m10: -0.14705425642099013,
        m11: 0.5183602715367776,
        m12: 0.04004282165408487,
        m20: 0.15996265166373125,
        m21: 0.0492912282128556,
        m22: 0.9684866957875502
    }
};
var $633ce119b108995d$export$2e2bcd8739ae039 = $633ce119b108995d$var$labConstants;
// taken from https://de.mathworks.com/help/images/ref/whitepoint.html
const $633ce119b108995d$var$ILLUMINANTS = new Map([
    // ASTM E308-01
    [
        'a',
        [
            1.0985,
            0.35585
        ]
    ],
    // Wyszecki & Stiles, p. 769
    [
        'b',
        [
            1.0985,
            0.35585
        ]
    ],
    // C ASTM E308-01
    [
        'c',
        [
            0.98074,
            1.18232
        ]
    ],
    // D50 (ASTM E308-01)
    [
        'd50',
        [
            0.96422,
            0.82521
        ]
    ],
    // D55 (ASTM E308-01)
    [
        'd55',
        [
            0.95682,
            0.92149
        ]
    ],
    // D65 (ASTM E308-01)
    [
        'd65',
        [
            0.95047,
            1.08883
        ]
    ],
    // E (ASTM E308-01)
    [
        'e',
        [
            1,
            1,
            1
        ]
    ],
    // F2 (ASTM E308-01)
    [
        'f2',
        [
            0.99186,
            0.67393
        ]
    ],
    // F7 (ASTM E308-01)
    [
        'f7',
        [
            0.95041,
            1.08747
        ]
    ],
    // F11 (ASTM E308-01)
    [
        'f11',
        [
            1.00962,
            0.6435
        ]
    ],
    [
        'icc',
        [
            0.96422,
            0.82521
        ]
    ]
]);
function $633ce119b108995d$export$23f27f4cae67c045(name) {
    const ill = $633ce119b108995d$var$ILLUMINANTS.get(String(name).toLowerCase());
    if (!ill) throw new Error('unknown Lab illuminant ' + name);
    $633ce119b108995d$var$labConstants.labWhitePoint = name;
    $633ce119b108995d$var$labConstants.Xn = ill[0];
    $633ce119b108995d$var$labConstants.Zn = ill[1];
}
function $633ce119b108995d$export$922c3afbcbc31cb3() {
    return $633ce119b108995d$var$labConstants.labWhitePoint;
}

});


parcelRegister("luvnN", function(module, exports) {

$parcel$export(module.exports, "rgb2xyz", () => $fa54be4b38a62f7b$export$fca6d690f89f5907);
$parcel$export(module.exports, "default", () => $fa54be4b38a62f7b$export$2e2bcd8739ae039);

var $8weUB = parcelRequire("8weUB");
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $fa54be4b38a62f7b$var$rgb2lab = (...args)=>{
    const [r, g, b, ...rest] = (0, $43ZPL.default)(args, 'rgb');
    const [x, y, z] = $fa54be4b38a62f7b$export$fca6d690f89f5907(r, g, b);
    const [L, a, b_] = $fa54be4b38a62f7b$var$xyz2lab(x, y, z);
    return [
        L,
        a,
        b_,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
function $fa54be4b38a62f7b$var$xyz2lab(x, y, z) {
    const { Xn: Xn, Yn: Yn, Zn: Zn, kE: kE, kK: kK } = (0, $8weUB.default);
    const xr = x / Xn;
    const yr = y / Yn;
    const zr = z / Zn;
    const fx = xr > kE ? Math.pow(xr, 1.0 / 3.0) : (kK * xr + 16.0) / 116.0;
    const fy = yr > kE ? Math.pow(yr, 1.0 / 3.0) : (kK * yr + 16.0) / 116.0;
    const fz = zr > kE ? Math.pow(zr, 1.0 / 3.0) : (kK * zr + 16.0) / 116.0;
    return [
        116.0 * fy - 16.0,
        500.0 * (fx - fy),
        200.0 * (fy - fz)
    ];
}
function $fa54be4b38a62f7b$var$gammaAdjustSRGB(companded) {
    const sign = Math.sign(companded);
    companded = Math.abs(companded);
    const linear = companded <= 0.04045 ? companded / 12.92 : Math.pow((companded + 0.055) / 1.055, 2.4);
    return linear * sign;
}
const $fa54be4b38a62f7b$export$fca6d690f89f5907 = (r, g, b)=>{
    // normalize and gamma adjust
    r = $fa54be4b38a62f7b$var$gammaAdjustSRGB(r / 255);
    g = $fa54be4b38a62f7b$var$gammaAdjustSRGB(g / 255);
    b = $fa54be4b38a62f7b$var$gammaAdjustSRGB(b / 255);
    const { MtxRGB2XYZ: MtxRGB2XYZ, MtxAdaptMa: MtxAdaptMa, MtxAdaptMaI: MtxAdaptMaI, Xn: Xn, Yn: Yn, Zn: Zn, As: As, Bs: Bs, Cs: Cs } = (0, $8weUB.default);
    let x = r * MtxRGB2XYZ.m00 + g * MtxRGB2XYZ.m10 + b * MtxRGB2XYZ.m20;
    let y = r * MtxRGB2XYZ.m01 + g * MtxRGB2XYZ.m11 + b * MtxRGB2XYZ.m21;
    let z = r * MtxRGB2XYZ.m02 + g * MtxRGB2XYZ.m12 + b * MtxRGB2XYZ.m22;
    const Ad = Xn * MtxAdaptMa.m00 + Yn * MtxAdaptMa.m10 + Zn * MtxAdaptMa.m20;
    const Bd = Xn * MtxAdaptMa.m01 + Yn * MtxAdaptMa.m11 + Zn * MtxAdaptMa.m21;
    const Cd = Xn * MtxAdaptMa.m02 + Yn * MtxAdaptMa.m12 + Zn * MtxAdaptMa.m22;
    let X = x * MtxAdaptMa.m00 + y * MtxAdaptMa.m10 + z * MtxAdaptMa.m20;
    let Y = x * MtxAdaptMa.m01 + y * MtxAdaptMa.m11 + z * MtxAdaptMa.m21;
    let Z = x * MtxAdaptMa.m02 + y * MtxAdaptMa.m12 + z * MtxAdaptMa.m22;
    X *= Ad / As;
    Y *= Bd / Bs;
    Z *= Cd / Cs;
    x = X * MtxAdaptMaI.m00 + Y * MtxAdaptMaI.m10 + Z * MtxAdaptMaI.m20;
    y = X * MtxAdaptMaI.m01 + Y * MtxAdaptMaI.m11 + Z * MtxAdaptMaI.m21;
    z = X * MtxAdaptMaI.m02 + Y * MtxAdaptMaI.m12 + Z * MtxAdaptMaI.m22;
    return [
        x,
        y,
        z
    ];
};
var $fa54be4b38a62f7b$export$2e2bcd8739ae039 = $fa54be4b38a62f7b$var$rgb2lab;

});



parcelRegister("kn0Pa", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
(0, $e7KSJ.default).prototype.get = function(mc) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) return src[i];
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else return src;
};

});

parcelRegister("hDPZe", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
const { pow: $cd7e67a33d66dde3$var$pow } = Math;
const $cd7e67a33d66dde3$var$EPS = 1e-7;
const $cd7e67a33d66dde3$var$MAX_ITER = 20;
(0, $e7KSJ.default).prototype.luminance = function(lum, mode = 'rgb') {
    if (lum !== undefined && (0, $hMEmV.default)(lum) === 'number') {
        if (lum === 0) // return pure black
        return new (0, $e7KSJ.default)([
            0,
            0,
            0,
            this._rgb[3]
        ], 'rgb');
        if (lum === 1) // return pure white
        return new (0, $e7KSJ.default)([
            255,
            255,
            255,
            this._rgb[3]
        ], 'rgb');
        // compute new color using...
        let cur_lum = this.luminance();
        let max_iter = $cd7e67a33d66dde3$var$MAX_ITER;
        const test = (low, high)=>{
            const mid = low.interpolate(high, 0.5, mode);
            const lm = mid.luminance();
            if (Math.abs(lum - lm) < $cd7e67a33d66dde3$var$EPS || !max_iter--) // close enough
            return mid;
            return lm > lum ? test(low, mid) : test(mid, high);
        };
        const rgb = (cur_lum > lum ? test(new (0, $e7KSJ.default)([
            0,
            0,
            0
        ]), this) : test(this, new (0, $e7KSJ.default)([
            255,
            255,
            255
        ]))).rgb();
        return new (0, $e7KSJ.default)([
            ...rgb,
            this._rgb[3]
        ]);
    }
    return $cd7e67a33d66dde3$var$rgb2luminance(...this._rgb.slice(0, 3));
};
const $cd7e67a33d66dde3$var$rgb2luminance = (r, g, b)=>{
    // relative luminance
    // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    r = $cd7e67a33d66dde3$var$luminance_x(r);
    g = $cd7e67a33d66dde3$var$luminance_x(g);
    b = $cd7e67a33d66dde3$var$luminance_x(b);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
const $cd7e67a33d66dde3$var$luminance_x = (x)=>{
    x /= 255;
    return x <= 0.03928 ? x / 12.92 : $cd7e67a33d66dde3$var$pow((x + 0.055) / 1.055, 2.4);
};

});

parcelRegister("eDzBg", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $dvq8W = parcelRequire("dvq8W");
(0, $e7KSJ.default).prototype.mix = (0, $e7KSJ.default).prototype.interpolate = function(col2, f = 0.5, ...rest) {
    return (0, $dvq8W.default)(this, col2, f, ...rest);
};

});
parcelRegister("dvq8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d52731f6acc42df$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $5flPP = parcelRequire("5flPP");
var $9d52731f6acc42df$export$2e2bcd8739ae039 = (col1, col2, f = 0.5, ...rest)=>{
    let mode = rest[0] || 'lrgb';
    if (!(0, $5flPP.default)[mode] && !rest.length) // fall back to the first supported mode
    mode = Object.keys((0, $5flPP.default))[0];
    if (!(0, $5flPP.default)[mode]) throw new Error(`interpolation mode ${mode} is not defined`);
    if ((0, $hMEmV.default)(col1) !== 'object') col1 = new (0, $e7KSJ.default)(col1);
    if ((0, $hMEmV.default)(col2) !== 'object') col2 = new (0, $e7KSJ.default)(col2);
    return (0, $5flPP.default)[mode](col1, col2, f).alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
};

});
parcelRegister("5flPP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d1f4a69308124ed$export$2e2bcd8739ae039);
var $3d1f4a69308124ed$export$2e2bcd8739ae039 = {};

});



parcelRegister("7pAyc", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
(0, $e7KSJ.default).prototype.premultiply = function(mutate = false) {
    const rgb = this._rgb;
    const a = rgb[3];
    if (mutate) {
        this._rgb = [
            rgb[0] * a,
            rgb[1] * a,
            rgb[2] * a,
            a
        ];
        return this;
    } else return new (0, $e7KSJ.default)([
        rgb[0] * a,
        rgb[1] * a,
        rgb[2] * a,
        a
    ], 'rgb');
};

});

parcelRegister("kXega", function(module, exports) {
parcelRequire("getAx");

var $e7KSJ = parcelRequire("e7KSJ");

var $8weUB = parcelRequire("8weUB");
(0, $e7KSJ.default).prototype.saturate = function(amount = 1) {
    const me = this;
    const lch = me.lch();
    lch[1] += (0, $8weUB.default).Kn * amount;
    if (lch[1] < 0) lch[1] = 0;
    return new (0, $e7KSJ.default)(lch, 'lch').alpha(me.alpha(), true);
};
(0, $e7KSJ.default).prototype.desaturate = function(amount = 1) {
    return this.saturate(-amount);
};

});
parcelRegister("getAx", function(module, exports) {

var $i4gda = parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $g4jd5 = parcelRequire("g4jd5");

var $c2Ykn = parcelRequire("c2Ykn");

var $jSfgf = parcelRequire("jSfgf");
(0, $e7KSJ.default).prototype.lch = function() {
    return (0, $jSfgf.default)(this._rgb);
};
(0, $e7KSJ.default).prototype.hcl = function() {
    return (0, $i4gda.reverse3)((0, $jSfgf.default)(this._rgb));
};
const $bd14e7c45dd3e1a2$export$5a21418738164530 = (...args)=>new (0, $e7KSJ.default)(...args, 'lch');
const $bd14e7c45dd3e1a2$export$d0e870ba50062ff1 = (...args)=>new (0, $e7KSJ.default)(...args, 'hcl');
Object.assign((0, $gaK1V.default), {
    lch: $bd14e7c45dd3e1a2$export$5a21418738164530,
    hcl: $bd14e7c45dd3e1a2$export$d0e870ba50062ff1
});
(0, $lT4NS.default).format.lch = (0, $g4jd5.default);
(0, $lT4NS.default).format.hcl = (0, $c2Ykn.default);
[
    'lch',
    'hcl'
].forEach((m)=>(0, $lT4NS.default).autodetect.push({
        p: 2,
        test: (...args)=>{
            args = (0, $43ZPL.default)(args, m);
            if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return m;
        }
    }));

});
parcelRegister("g4jd5", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb2bebced39c863d$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $d6n2X = parcelRequire("d6n2X");

var $jenZn = parcelRequire("jenZn");
const $bb2bebced39c863d$var$lch2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'lch');
    const [l, c, h] = args;
    const [L, a, b_] = (0, $d6n2X.default)(l, c, h);
    const [r, g, b] = (0, $jenZn.default)(L, a, b_);
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $bb2bebced39c863d$export$2e2bcd8739ae039 = $bb2bebced39c863d$var$lch2rgb;

});
parcelRegister("d6n2X", function(module, exports) {

$parcel$export(module.exports, "default", () => $989db6829fcafd4a$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { sin: $989db6829fcafd4a$var$sin, cos: $989db6829fcafd4a$var$cos } = Math;
const $989db6829fcafd4a$var$lch2lab = (...args)=>{
    /*
    Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
    These formulas were invented by David Dalrymple to obtain maximum contrast without going
    out of gamut if the parameters are in the range 0-1.

    A saturation multiplier was added by Gregor Aisch
    */ let [l, c, h] = (0, $43ZPL.default)(args, 'lch');
    if (isNaN(h)) h = 0;
    h = h * (0, $i4gda.DEG2RAD);
    return [
        l,
        $989db6829fcafd4a$var$cos(h) * c,
        $989db6829fcafd4a$var$sin(h) * c
    ];
};
var $989db6829fcafd4a$export$2e2bcd8739ae039 = $989db6829fcafd4a$var$lch2lab;

});


parcelRegister("c2Ykn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c5477bbf42a48d0$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $g4jd5 = parcelRequire("g4jd5");
const $8c5477bbf42a48d0$var$hcl2rgb = (...args)=>{
    const hcl = (0, $i4gda.reverse3)((0, $43ZPL.default)(args, 'hcl'));
    return (0, $g4jd5.default)(...hcl);
};
var $8c5477bbf42a48d0$export$2e2bcd8739ae039 = $8c5477bbf42a48d0$var$hcl2rgb;

});

parcelRegister("jSfgf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e77ee5fe83442dbf$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $luvnN = parcelRequire("luvnN");

var $36WLn = parcelRequire("36WLn");
const $e77ee5fe83442dbf$var$rgb2lch = (...args)=>{
    const [r, g, b, ...rest] = (0, $43ZPL.default)(args, 'rgb');
    const [l, a, b_] = (0, $luvnN.default)(r, g, b);
    const [L, c, h] = (0, $36WLn.default)(l, a, b_);
    return [
        L,
        c,
        h,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $e77ee5fe83442dbf$export$2e2bcd8739ae039 = $e77ee5fe83442dbf$var$rgb2lch;

});
parcelRegister("36WLn", function(module, exports) {

$parcel$export(module.exports, "default", () => $243f83c61b0760ca$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { sqrt: $243f83c61b0760ca$var$sqrt, atan2: $243f83c61b0760ca$var$atan2, round: $243f83c61b0760ca$var$round } = Math;
const $243f83c61b0760ca$var$lab2lch = (...args)=>{
    const [l, a, b] = (0, $43ZPL.default)(args, 'lab');
    const c = $243f83c61b0760ca$var$sqrt(a * a + b * b);
    let h = ($243f83c61b0760ca$var$atan2(b, a) * (0, $i4gda.RAD2DEG) + 360) % 360;
    if ($243f83c61b0760ca$var$round(c * 10000) === 0) h = Number.NaN;
    return [
        l,
        c,
        h
    ];
};
var $243f83c61b0760ca$export$2e2bcd8739ae039 = $243f83c61b0760ca$var$lab2lch;

});




parcelRegister("8P76D", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
(0, $e7KSJ.default).prototype.set = function(mc, value, mutate = false) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) {
            if ((0, $hMEmV.default)(value) == 'string') switch(value.charAt(0)){
                case '+':
                    src[i] += +value;
                    break;
                case '-':
                    src[i] += +value;
                    break;
                case '*':
                    src[i] *= +value.substr(1);
                    break;
                case '/':
                    src[i] /= +value.substr(1);
                    break;
                default:
                    src[i] = +value;
            }
            else if ((0, $hMEmV.default)(value) === 'number') src[i] = value;
            else throw new Error(`unsupported value for Color.set`);
            const out = new (0, $e7KSJ.default)(src, mode);
            if (mutate) {
                this._rgb = out._rgb;
                return this;
            }
            return out;
        }
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else return src;
};

});

parcelRegister("bEZjX", function(module, exports) {
parcelRequire("996dd");

var $e7KSJ = parcelRequire("e7KSJ");

var $dvq8W = parcelRequire("dvq8W");
(0, $e7KSJ.default).prototype.tint = function(f = 0.5, ...rest) {
    return (0, $dvq8W.default)(this, 'white', f, ...rest);
};
(0, $e7KSJ.default).prototype.shade = function(f = 0.5, ...rest) {
    return (0, $dvq8W.default)(this, 'black', f, ...rest);
};

});

parcelRegister("jywIV", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $5flPP = parcelRequire("5flPP");
const $e3ca93847035084a$var$rgb = (col1, col2, f)=>{
    const xyz0 = col1._rgb;
    const xyz1 = col2._rgb;
    return new (0, $e7KSJ.default)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'rgb');
};
// register interpolator
(0, $5flPP.default).rgb = $e3ca93847035084a$var$rgb;
var $e3ca93847035084a$export$2e2bcd8739ae039 = $e3ca93847035084a$var$rgb;

});

parcelRegister("4Zhp6", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $5flPP = parcelRequire("5flPP");
const { sqrt: $3a1a5bf678f2834b$var$sqrt, pow: $3a1a5bf678f2834b$var$pow } = Math;
const $3a1a5bf678f2834b$var$lrgb = (col1, col2, f)=>{
    const [x1, y1, z1] = col1._rgb;
    const [x2, y2, z2] = col2._rgb;
    return new (0, $e7KSJ.default)($3a1a5bf678f2834b$var$sqrt($3a1a5bf678f2834b$var$pow(x1, 2) * (1 - f) + $3a1a5bf678f2834b$var$pow(x2, 2) * f), $3a1a5bf678f2834b$var$sqrt($3a1a5bf678f2834b$var$pow(y1, 2) * (1 - f) + $3a1a5bf678f2834b$var$pow(y2, 2) * f), $3a1a5bf678f2834b$var$sqrt($3a1a5bf678f2834b$var$pow(z1, 2) * (1 - f) + $3a1a5bf678f2834b$var$pow(z2, 2) * f), 'rgb');
};
// register interpolator
(0, $5flPP.default).lrgb = $3a1a5bf678f2834b$var$lrgb;
var $3a1a5bf678f2834b$export$2e2bcd8739ae039 = $3a1a5bf678f2834b$var$lrgb;

});

parcelRegister("kMTGA", function(module, exports) {
parcelRequire("996dd");

var $5flPP = parcelRequire("5flPP");

var $e7KSJ = parcelRequire("e7KSJ");
const $f2237c656cb48337$var$lab = (col1, col2, f)=>{
    const xyz0 = col1.lab();
    const xyz1 = col2.lab();
    return new (0, $e7KSJ.default)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'lab');
};
// register interpolator
(0, $5flPP.default).lab = $f2237c656cb48337$var$lab;
var $f2237c656cb48337$export$2e2bcd8739ae039 = $f2237c656cb48337$var$lab;

});

parcelRegister("dkzY3", function(module, exports) {
parcelRequire("getAx");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $9b490b0c3a354cd6$var$lch = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'lch');
};
// register interpolator
(0, $5flPP.default).lch = $9b490b0c3a354cd6$var$lch;
(0, $5flPP.default).hcl = $9b490b0c3a354cd6$var$lch;
var $9b490b0c3a354cd6$export$2e2bcd8739ae039 = $9b490b0c3a354cd6$var$lch;

});
parcelRegister("9mSMN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d20aa787a33a4e5$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
var $6d20aa787a33a4e5$export$2e2bcd8739ae039 = (col1, col2, f, m)=>{
    let xyz0, xyz1;
    if (m === 'hsl') {
        xyz0 = col1.hsl();
        xyz1 = col2.hsl();
    } else if (m === 'hsv') {
        xyz0 = col1.hsv();
        xyz1 = col2.hsv();
    } else if (m === 'hcg') {
        xyz0 = col1.hcg();
        xyz1 = col2.hcg();
    } else if (m === 'hsi') {
        xyz0 = col1.hsi();
        xyz1 = col2.hsi();
    } else if (m === 'lch' || m === 'hcl') {
        m = 'hcl';
        xyz0 = col1.hcl();
        xyz1 = col2.hcl();
    } else if (m === 'oklch') {
        xyz0 = col1.oklch().reverse();
        xyz1 = col2.oklch().reverse();
    }
    let hue0, hue1, sat0, sat1, lbv0, lbv1;
    if (m.substr(0, 1) === 'h' || m === 'oklch') {
        [hue0, sat0, lbv0] = xyz0;
        [hue1, sat1, lbv1] = xyz1;
    }
    let sat, hue, lbv, dh;
    if (!isNaN(hue0) && !isNaN(hue1)) {
        // both colors have hue
        if (hue1 > hue0 && hue1 - hue0 > 180) dh = hue1 - (hue0 + 360);
        else if (hue1 < hue0 && hue0 - hue1 > 180) dh = hue1 + 360 - hue0;
        else dh = hue1 - hue0;
        hue = hue0 + f * dh;
    } else if (!isNaN(hue0)) {
        hue = hue0;
        if ((lbv1 == 1 || lbv1 == 0) && m != 'hsv') sat = sat0;
    } else if (!isNaN(hue1)) {
        hue = hue1;
        if ((lbv0 == 1 || lbv0 == 0) && m != 'hsv') sat = sat1;
    } else hue = Number.NaN;
    if (sat === undefined) sat = sat0 + f * (sat1 - sat0);
    lbv = lbv0 + f * (lbv1 - lbv0);
    return m === 'oklch' ? new (0, $e7KSJ.default)([
        lbv,
        sat,
        hue
    ], m) : new (0, $e7KSJ.default)([
        hue,
        sat,
        lbv
    ], m);
};

});


parcelRegister("gac9F", function(module, exports) {
parcelRequire("eSrDz");

var $5flPP = parcelRequire("5flPP");

var $e7KSJ = parcelRequire("e7KSJ");
const $bc4702376fdac141$var$num = (col1, col2, f)=>{
    const c1 = col1.num();
    const c2 = col2.num();
    return new (0, $e7KSJ.default)(c1 + f * (c2 - c1), 'num');
};
// register interpolator
(0, $5flPP.default).num = $bc4702376fdac141$var$num;
var $bc4702376fdac141$export$2e2bcd8739ae039 = $bc4702376fdac141$var$num;

});
parcelRegister("eSrDz", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $2UY7c = parcelRequire("2UY7c");

var $gkdTd = parcelRequire("gkdTd");
(0, $e7KSJ.default).prototype.num = function() {
    return (0, $gkdTd.default)(this._rgb);
};
const $ad4b8c09bf38a2ac$export$61cc6a0be4938a2a = (...args)=>new (0, $e7KSJ.default)(...args, 'num');
Object.assign((0, $gaK1V.default), {
    num: $ad4b8c09bf38a2ac$export$61cc6a0be4938a2a
});
(0, $lT4NS.default).format.num = (0, $2UY7c.default);
(0, $lT4NS.default).autodetect.push({
    p: 5,
    test: (...args)=>{
        if (args.length === 1 && (0, $hMEmV.default)(args[0]) === 'number' && args[0] >= 0 && args[0] <= 0xffffff) return 'num';
    }
});

});
parcelRegister("2UY7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $21ff7154ad573d00$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
const $21ff7154ad573d00$var$num2rgb = (num)=>{
    if ((0, $hMEmV.default)(num) == 'number' && num >= 0 && num <= 0xffffff) {
        const r = num >> 16;
        const g = num >> 8 & 0xff;
        const b = num & 0xff;
        return [
            r,
            g,
            b,
            1
        ];
    }
    throw new Error('unknown num color: ' + num);
};
var $21ff7154ad573d00$export$2e2bcd8739ae039 = $21ff7154ad573d00$var$num2rgb;

});

parcelRegister("gkdTd", function(module, exports) {

$parcel$export(module.exports, "default", () => $be2949c4ecd598fe$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $be2949c4ecd598fe$var$rgb2num = (...args)=>{
    const [r, g, b] = (0, $43ZPL.default)(args, 'rgb');
    return (r << 16) + (g << 8) + b;
};
var $be2949c4ecd598fe$export$2e2bcd8739ae039 = $be2949c4ecd598fe$var$rgb2num;

});



parcelRegister("fWmFX", function(module, exports) {
parcelRequire("hskHC");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $b9addcb425bc1f3f$var$hcg = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'hcg');
};
// register interpolator
(0, $5flPP.default).hcg = $b9addcb425bc1f3f$var$hcg;
var $b9addcb425bc1f3f$export$2e2bcd8739ae039 = $b9addcb425bc1f3f$var$hcg;

});
parcelRegister("hskHC", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $lQebz = parcelRequire("lQebz");

var $66Tfa = parcelRequire("66Tfa");
(0, $e7KSJ.default).prototype.hcg = function() {
    return (0, $66Tfa.default)(this._rgb);
};
const $cb551c44f4ef224a$export$e588e1c8c259384c = (...args)=>new (0, $e7KSJ.default)(...args, 'hcg');
(0, $gaK1V.default).hcg = $cb551c44f4ef224a$export$e588e1c8c259384c;
(0, $lT4NS.default).format.hcg = (0, $lQebz.default);
(0, $lT4NS.default).autodetect.push({
    p: 1,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'hcg');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'hcg';
    }
});

});
parcelRegister("lQebz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe697541ee37e71b$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { floor: $fe697541ee37e71b$var$floor } = Math;
/*
 * this is basically just HSV with some minor tweaks
 *
 * hue.. [0..360]
 * chroma .. [0..1]
 * grayness .. [0..1]
 */ const $fe697541ee37e71b$var$hcg2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'hcg');
    let [h, c, _g] = args;
    let r, g, b;
    _g = _g * 255;
    const _c = c * 255;
    if (c === 0) r = g = b = _g;
    else {
        if (h === 360) h = 0;
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 60;
        const i = $fe697541ee37e71b$var$floor(h);
        const f = h - i;
        const p = _g * (1 - c);
        const q = p + _c * (1 - f);
        const t = p + _c * f;
        const v = p + _c;
        switch(i){
            case 0:
                [r, g, b] = [
                    v,
                    t,
                    p
                ];
                break;
            case 1:
                [r, g, b] = [
                    q,
                    v,
                    p
                ];
                break;
            case 2:
                [r, g, b] = [
                    p,
                    v,
                    t
                ];
                break;
            case 3:
                [r, g, b] = [
                    p,
                    q,
                    v
                ];
                break;
            case 4:
                [r, g, b] = [
                    t,
                    p,
                    v
                ];
                break;
            case 5:
                [r, g, b] = [
                    v,
                    p,
                    q
                ];
                break;
        }
    }
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $fe697541ee37e71b$export$2e2bcd8739ae039 = $fe697541ee37e71b$var$hcg2rgb;

});

parcelRegister("66Tfa", function(module, exports) {

$parcel$export(module.exports, "default", () => $472e27dbd8c4997e$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $472e27dbd8c4997e$var$rgb2hcg = (...args)=>{
    const [r, g, b] = (0, $43ZPL.default)(args, 'rgb');
    const minRgb = (0, $i4gda.min)(r, g, b);
    const maxRgb = (0, $i4gda.max)(r, g, b);
    const delta = maxRgb - minRgb;
    const c = delta * 100 / 255;
    const _g = minRgb / (255 - delta) * 100;
    let h;
    if (delta === 0) h = Number.NaN;
    else {
        if (r === maxRgb) h = (g - b) / delta;
        if (g === maxRgb) h = 2 + (b - r) / delta;
        if (b === maxRgb) h = 4 + (r - g) / delta;
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        h,
        c,
        _g
    ];
};
var $472e27dbd8c4997e$export$2e2bcd8739ae039 = $472e27dbd8c4997e$var$rgb2hcg;

});



parcelRegister("3s82t", function(module, exports) {
parcelRequire("2yZD4");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $283a38fc382f3b9d$var$hsi = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'hsi');
};
// register interpolator
(0, $5flPP.default).hsi = $283a38fc382f3b9d$var$hsi;
var $283a38fc382f3b9d$export$2e2bcd8739ae039 = $283a38fc382f3b9d$var$hsi;

});
parcelRegister("2yZD4", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $l5tcy = parcelRequire("l5tcy");

var $jIBUL = parcelRequire("jIBUL");
(0, $e7KSJ.default).prototype.hsi = function() {
    return (0, $jIBUL.default)(this._rgb);
};
const $1dde90099f253c78$export$ec0e0a10cc3c404a = (...args)=>new (0, $e7KSJ.default)(...args, 'hsi');
(0, $gaK1V.default).hsi = $1dde90099f253c78$export$ec0e0a10cc3c404a;
(0, $lT4NS.default).format.hsi = (0, $l5tcy.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'hsi');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'hsi';
    }
});

});
parcelRegister("l5tcy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5a0b7662948a353$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $gb2Ug = parcelRequire("gb2Ug");
var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { cos: $f5a0b7662948a353$var$cos } = Math;
/*
 * hue [0..360]
 * saturation [0..1]
 * intensity [0..1]
 */ const $f5a0b7662948a353$var$hsi2rgb = (...args)=>{
    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
    */ args = (0, $43ZPL.default)(args, 'hsi');
    let [h, s, i] = args;
    let r, g, b;
    if (isNaN(h)) h = 0;
    if (isNaN(s)) s = 0;
    // normalize hue
    if (h > 360) h -= 360;
    if (h < 0) h += 360;
    h /= 360;
    if (h < 1 / 3) {
        b = (1 - s) / 3;
        r = (1 + s * $f5a0b7662948a353$var$cos((0, $i4gda.TWOPI) * h) / $f5a0b7662948a353$var$cos((0, $i4gda.PITHIRD) - (0, $i4gda.TWOPI) * h)) / 3;
        g = 1 - (b + r);
    } else if (h < 2 / 3) {
        h -= 1 / 3;
        r = (1 - s) / 3;
        g = (1 + s * $f5a0b7662948a353$var$cos((0, $i4gda.TWOPI) * h) / $f5a0b7662948a353$var$cos((0, $i4gda.PITHIRD) - (0, $i4gda.TWOPI) * h)) / 3;
        b = 1 - (r + g);
    } else {
        h -= 2 / 3;
        g = (1 - s) / 3;
        b = (1 + s * $f5a0b7662948a353$var$cos((0, $i4gda.TWOPI) * h) / $f5a0b7662948a353$var$cos((0, $i4gda.PITHIRD) - (0, $i4gda.TWOPI) * h)) / 3;
        r = 1 - (g + b);
    }
    r = (0, $gb2Ug.default)(i * r * 3);
    g = (0, $gb2Ug.default)(i * g * 3);
    b = (0, $gb2Ug.default)(i * b * 3);
    return [
        r * 255,
        g * 255,
        b * 255,
        args.length > 3 ? args[3] : 1
    ];
};
var $f5a0b7662948a353$export$2e2bcd8739ae039 = $f5a0b7662948a353$var$hsi2rgb;

});

parcelRegister("jIBUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5af8966c377d585$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { min: $e5af8966c377d585$var$min, sqrt: $e5af8966c377d585$var$sqrt, acos: $e5af8966c377d585$var$acos } = Math;
const $e5af8966c377d585$var$rgb2hsi = (...args)=>{
    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
    */ let [r, g, b] = (0, $43ZPL.default)(args, 'rgb');
    r /= 255;
    g /= 255;
    b /= 255;
    let h;
    const min_ = $e5af8966c377d585$var$min(r, g, b);
    const i = (r + g + b) / 3;
    const s = i > 0 ? 1 - min_ / i : 0;
    if (s === 0) h = NaN;
    else {
        h = (r - g + (r - b)) / 2;
        h /= $e5af8966c377d585$var$sqrt((r - g) * (r - g) + (r - b) * (g - b));
        h = $e5af8966c377d585$var$acos(h);
        if (b > g) h = (0, $i4gda.TWOPI) - h;
        h /= (0, $i4gda.TWOPI);
    }
    return [
        h * 360,
        s,
        i
    ];
};
var $e5af8966c377d585$export$2e2bcd8739ae039 = $e5af8966c377d585$var$rgb2hsi;

});



parcelRegister("75dqB", function(module, exports) {
parcelRequire("fbI2I");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $52836a91adc4a3f4$var$hsl = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'hsl');
};
// register interpolator
(0, $5flPP.default).hsl = $52836a91adc4a3f4$var$hsl;
var $52836a91adc4a3f4$export$2e2bcd8739ae039 = $52836a91adc4a3f4$var$hsl;

});
parcelRegister("fbI2I", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $7PGtI = parcelRequire("7PGtI");

var $f9fTr = parcelRequire("f9fTr");
(0, $e7KSJ.default).prototype.hsl = function() {
    return (0, $f9fTr.default)(this._rgb);
};
const $b0ea0c19eddc0159$export$8f4a7c0bb78e6ea8 = (...args)=>new (0, $e7KSJ.default)(...args, 'hsl');
(0, $gaK1V.default).hsl = $b0ea0c19eddc0159$export$8f4a7c0bb78e6ea8;
(0, $lT4NS.default).format.hsl = (0, $7PGtI.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'hsl');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'hsl';
    }
});

});
parcelRegister("7PGtI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b3e3f1c3bcf972f$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $5b3e3f1c3bcf972f$var$hsl2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'hsl');
    const [h, s, l] = args;
    let r, g, b;
    if (s === 0) r = g = b = l * 255;
    else {
        const t3 = [
            0,
            0,
            0
        ];
        const c = [
            0,
            0,
            0
        ];
        const t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const t1 = 2 * l - t2;
        const h_ = h / 360;
        t3[0] = h_ + 1 / 3;
        t3[1] = h_;
        t3[2] = h_ - 1 / 3;
        for(let i = 0; i < 3; i++){
            if (t3[i] < 0) t3[i] += 1;
            if (t3[i] > 1) t3[i] -= 1;
            if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];
            else if (2 * t3[i] < 1) c[i] = t2;
            else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;
            else c[i] = t1;
        }
        [r, g, b] = [
            c[0] * 255,
            c[1] * 255,
            c[2] * 255
        ];
    }
    if (args.length > 3) // keep alpha channel
    return [
        r,
        g,
        b,
        args[3]
    ];
    return [
        r,
        g,
        b,
        1
    ];
};
var $5b3e3f1c3bcf972f$export$2e2bcd8739ae039 = $5b3e3f1c3bcf972f$var$hsl2rgb;

});

parcelRegister("f9fTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0740654f8b78640$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * supported arguments:
 * - rgb2hsl(r,g,b)
 * - rgb2hsl(r,g,b,a)
 * - rgb2hsl([r,g,b])
 * - rgb2hsl([r,g,b,a])
 * - rgb2hsl({r,g,b,a})
 */ const $b0740654f8b78640$var$rgb2hsl = (...args)=>{
    args = (0, $43ZPL.default)(args, 'rgba');
    let [r, g, b] = args;
    r /= 255;
    g /= 255;
    b /= 255;
    const minRgb = (0, $i4gda.min)(r, g, b);
    const maxRgb = (0, $i4gda.max)(r, g, b);
    const l = (maxRgb + minRgb) / 2;
    let s, h;
    if (maxRgb === minRgb) {
        s = 0;
        h = Number.NaN;
    } else s = l < 0.5 ? (maxRgb - minRgb) / (maxRgb + minRgb) : (maxRgb - minRgb) / (2 - maxRgb - minRgb);
    if (r == maxRgb) h = (g - b) / (maxRgb - minRgb);
    else if (g == maxRgb) h = 2 + (b - r) / (maxRgb - minRgb);
    else if (b == maxRgb) h = 4 + (r - g) / (maxRgb - minRgb);
    h *= 60;
    if (h < 0) h += 360;
    if (args.length > 3 && args[3] !== undefined) return [
        h,
        s,
        l,
        args[3]
    ];
    return [
        h,
        s,
        l
    ];
};
var $b0740654f8b78640$export$2e2bcd8739ae039 = $b0740654f8b78640$var$rgb2hsl;

});



parcelRegister("2ISBM", function(module, exports) {
parcelRequire("7Z9E2");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $1fba0cefa8ec10d2$var$hsv = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'hsv');
};
// register interpolator
(0, $5flPP.default).hsv = $1fba0cefa8ec10d2$var$hsv;
var $1fba0cefa8ec10d2$export$2e2bcd8739ae039 = $1fba0cefa8ec10d2$var$hsv;

});
parcelRegister("7Z9E2", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $eNZr2 = parcelRequire("eNZr2");

var $8GFTU = parcelRequire("8GFTU");
(0, $e7KSJ.default).prototype.hsv = function() {
    return (0, $8GFTU.default)(this._rgb);
};
const $5d05b62ca5e0b832$export$a5d7c789f12d2213 = (...args)=>new (0, $e7KSJ.default)(...args, 'hsv');
(0, $gaK1V.default).hsv = $5d05b62ca5e0b832$export$a5d7c789f12d2213;
(0, $lT4NS.default).format.hsv = (0, $eNZr2.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'hsv');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'hsv';
    }
});

});
parcelRegister("eNZr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $02c815df05a1cd8b$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { floor: $02c815df05a1cd8b$var$floor } = Math;
const $02c815df05a1cd8b$var$hsv2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'hsv');
    let [h, s, v] = args;
    let r, g, b;
    v *= 255;
    if (s === 0) r = g = b = v;
    else {
        if (h === 360) h = 0;
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 60;
        const i = $02c815df05a1cd8b$var$floor(h);
        const f = h - i;
        const p = v * (1 - s);
        const q = v * (1 - s * f);
        const t = v * (1 - s * (1 - f));
        switch(i){
            case 0:
                [r, g, b] = [
                    v,
                    t,
                    p
                ];
                break;
            case 1:
                [r, g, b] = [
                    q,
                    v,
                    p
                ];
                break;
            case 2:
                [r, g, b] = [
                    p,
                    v,
                    t
                ];
                break;
            case 3:
                [r, g, b] = [
                    p,
                    q,
                    v
                ];
                break;
            case 4:
                [r, g, b] = [
                    t,
                    p,
                    v
                ];
                break;
            case 5:
                [r, g, b] = [
                    v,
                    p,
                    q
                ];
                break;
        }
    }
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $02c815df05a1cd8b$export$2e2bcd8739ae039 = $02c815df05a1cd8b$var$hsv2rgb;

});

parcelRegister("8GFTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6532bf9b6866bc48$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { min: $6532bf9b6866bc48$var$min, max: $6532bf9b6866bc48$var$max } = Math;
/*
 * supported arguments:
 * - rgb2hsv(r,g,b)
 * - rgb2hsv([r,g,b])
 * - rgb2hsv({r,g,b})
 */ const $6532bf9b6866bc48$var$rgb2hsl = (...args)=>{
    args = (0, $43ZPL.default)(args, 'rgb');
    let [r, g, b] = args;
    const min_ = $6532bf9b6866bc48$var$min(r, g, b);
    const max_ = $6532bf9b6866bc48$var$max(r, g, b);
    const delta = max_ - min_;
    let h, s, v;
    v = max_ / 255.0;
    if (max_ === 0) {
        h = Number.NaN;
        s = 0;
    } else {
        s = delta / max_;
        if (r === max_) h = (g - b) / delta;
        if (g === max_) h = 2 + (b - r) / delta;
        if (b === max_) h = 4 + (r - g) / delta;
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        h,
        s,
        v
    ];
};
var $6532bf9b6866bc48$export$2e2bcd8739ae039 = $6532bf9b6866bc48$var$rgb2hsl;

});



parcelRegister("52gBS", function(module, exports) {
parcelRequire("j6weT");

var $5flPP = parcelRequire("5flPP");

var $e7KSJ = parcelRequire("e7KSJ");
const $3aaa060894ca8484$var$oklab = (col1, col2, f)=>{
    const xyz0 = col1.oklab();
    const xyz1 = col2.oklab();
    return new (0, $e7KSJ.default)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'oklab');
};
// register interpolator
(0, $5flPP.default).oklab = $3aaa060894ca8484$var$oklab;
var $3aaa060894ca8484$export$2e2bcd8739ae039 = $3aaa060894ca8484$var$oklab;

});
parcelRegister("j6weT", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $5D4bx = parcelRequire("5D4bx");

var $eJb2q = parcelRequire("eJb2q");
(0, $e7KSJ.default).prototype.oklab = function() {
    return (0, $eJb2q.default)(this._rgb);
};
const $de8795def78a20d0$export$b14b17e4e916d621 = (...args)=>new (0, $e7KSJ.default)(...args, 'oklab');
Object.assign((0, $gaK1V.default), {
    oklab: $de8795def78a20d0$export$b14b17e4e916d621
});
(0, $lT4NS.default).format.oklab = (0, $5D4bx.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'oklab');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'oklab';
    }
});

});
parcelRegister("5D4bx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4193d753772cec6b$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $iIsar = parcelRequire("iIsar");

var $jenZn = parcelRequire("jenZn");
const $4193d753772cec6b$var$oklab2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'lab');
    const [L, a, b, ...rest] = args;
    const [X, Y, Z] = $4193d753772cec6b$var$OKLab_to_XYZ([
        L,
        a,
        b
    ]);
    const [r, g, b_] = (0, $jenZn.xyz2rgb)(X, Y, Z);
    return [
        r,
        g,
        b_,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
// from https://www.w3.org/TR/css-color-4/#color-conversion-code
function $4193d753772cec6b$var$OKLab_to_XYZ(OKLab) {
    // Given OKLab, convert to XYZ relative to D65
    var LMStoXYZ = [
        [
            1.2268798758459243,
            -0.5578149944602171,
            0.2813910456659647
        ],
        [
            -0.0405757452148008,
            1.112286803280317,
            -0.0717110580655164
        ],
        [
            -0.0763729366746601,
            -0.4214933324022432,
            1.5869240198367816
        ]
    ];
    var OKLabtoLMS = [
        [
            1.0,
            0.3963377773761749,
            0.2158037573099136
        ],
        [
            1.0,
            -0.1055613458156586,
            -0.0638541728258133
        ],
        [
            1.0,
            -0.0894841775298119,
            -1.2914855480194092
        ]
    ];
    var LMSnl = (0, $iIsar.default)(OKLabtoLMS, OKLab);
    return (0, $iIsar.default)(LMStoXYZ, LMSnl.map((c)=>c ** 3));
}
var $4193d753772cec6b$export$2e2bcd8739ae039 = $4193d753772cec6b$var$oklab2rgb;

});
parcelRegister("iIsar", function(module, exports) {

$parcel$export(module.exports, "default", () => $da022f8598f5340d$export$2e2bcd8739ae039);
// from https://www.w3.org/TR/css-color-4/multiply-matrices.js
function $da022f8598f5340d$export$2e2bcd8739ae039(A, B) {
    let m = A.length;
    if (!Array.isArray(A[0])) // A is vector, convert to [[a, b, c, ...]]
    A = [
        A
    ];
    if (!Array.isArray(B[0])) // B is vector, convert to [[a], [b], [c], ...]]
    B = B.map((x)=>[
            x
        ]);
    let p = B[0].length;
    let B_cols = B[0].map((_, i)=>B.map((x)=>x[i])); // transpose B
    let product = A.map((row)=>B_cols.map((col)=>{
            if (!Array.isArray(row)) return col.reduce((a, c)=>a + c * row, 0);
            return row.reduce((a, c, i)=>a + c * (col[i] || 0), 0);
        }));
    if (m === 1) product = product[0]; // Avoid [[a, b, c, ...]]
    if (p === 1) return product.map((x)=>x[0]); // Avoid [[a], [b], [c], ...]]
    return product;
}

});


parcelRegister("eJb2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8dd493bc48c920$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $iIsar = parcelRequire("iIsar");

var $luvnN = parcelRequire("luvnN");
const $ab8dd493bc48c920$var$rgb2oklab = (...args)=>{
    const [r, g, b, ...rest] = (0, $43ZPL.default)(args, 'rgb');
    const xyz = (0, $luvnN.rgb2xyz)(r, g, b);
    const oklab = $ab8dd493bc48c920$var$XYZ_to_OKLab(xyz);
    return [
        ...oklab,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
// from https://www.w3.org/TR/css-color-4/#color-conversion-code
function $ab8dd493bc48c920$var$XYZ_to_OKLab(XYZ) {
    // Given XYZ relative to D65, convert to OKLab
    const XYZtoLMS = [
        [
            0.819022437996703,
            0.3619062600528904,
            -0.1288737815209879
        ],
        [
            0.0329836539323885,
            0.9292868615863434,
            0.0361446663506424
        ],
        [
            0.0481771893596242,
            0.2642395317527308,
            0.6335478284694309
        ]
    ];
    const LMStoOKLab = [
        [
            0.210454268309314,
            0.7936177747023054,
            -0.0040720430116193
        ],
        [
            1.9779985324311684,
            -2.42859224204858,
            0.450593709617411
        ],
        [
            0.0259040424655478,
            0.7827717124575296,
            -0.8086757549230774
        ]
    ];
    const LMS = (0, $iIsar.default)(XYZtoLMS, XYZ);
    // JavaScript Math.cbrt returns a sign-matched cube root
    // beware if porting to other languages
    // especially if tempted to use a general power function
    return (0, $iIsar.default)(LMStoOKLab, LMS.map((c)=>Math.cbrt(c)));
// L in range [0,1]. For use in CSS, multiply by 100 and add a percent
}
var $ab8dd493bc48c920$export$2e2bcd8739ae039 = $ab8dd493bc48c920$var$rgb2oklab;

});



parcelRegister("3wKag", function(module, exports) {
parcelRequire("getAx");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $29182b9272ebb9ac$var$oklch = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'oklch');
};
// register interpolator
(0, $5flPP.default).oklch = $29182b9272ebb9ac$var$oklch;
var $29182b9272ebb9ac$export$2e2bcd8739ae039 = $29182b9272ebb9ac$var$oklch;

});

parcelRegister("8UmTp", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c54fb1da1f0bdc$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $8TO5X = parcelRequire("8TO5X");
const { pow: $67c54fb1da1f0bdc$var$pow, sqrt: $67c54fb1da1f0bdc$var$sqrt, PI: $67c54fb1da1f0bdc$var$PI, cos: $67c54fb1da1f0bdc$var$cos, sin: $67c54fb1da1f0bdc$var$sin, atan2: $67c54fb1da1f0bdc$var$atan2 } = Math;
var $67c54fb1da1f0bdc$export$2e2bcd8739ae039 = (colors, mode = 'lrgb', weights = null)=>{
    const l = colors.length;
    if (!weights) weights = Array.from(new Array(l)).map(()=>1);
    // normalize weights
    const k = l / weights.reduce(function(a, b) {
        return a + b;
    });
    weights.forEach((w, i)=>{
        weights[i] *= k;
    });
    // convert colors to Color objects
    colors = colors.map((c)=>new (0, $e7KSJ.default)(c));
    if (mode === 'lrgb') return $67c54fb1da1f0bdc$var$_average_lrgb(colors, weights);
    const first = colors.shift();
    const xyz = first.get(mode);
    const cnt = [];
    let dx = 0;
    let dy = 0;
    // initial color
    for(let i = 0; i < xyz.length; i++){
        xyz[i] = (xyz[i] || 0) * weights[0];
        cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
        if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
            const A = xyz[i] / 180 * $67c54fb1da1f0bdc$var$PI;
            dx += $67c54fb1da1f0bdc$var$cos(A) * weights[0];
            dy += $67c54fb1da1f0bdc$var$sin(A) * weights[0];
        }
    }
    let alpha = first.alpha() * weights[0];
    colors.forEach((c, ci)=>{
        const xyz2 = c.get(mode);
        alpha += c.alpha() * weights[ci + 1];
        for(let i = 0; i < xyz.length; i++)if (!isNaN(xyz2[i])) {
            cnt[i] += weights[ci + 1];
            if (mode.charAt(i) === 'h') {
                const A = xyz2[i] / 180 * $67c54fb1da1f0bdc$var$PI;
                dx += $67c54fb1da1f0bdc$var$cos(A) * weights[ci + 1];
                dy += $67c54fb1da1f0bdc$var$sin(A) * weights[ci + 1];
            } else xyz[i] += xyz2[i] * weights[ci + 1];
        }
    });
    for(let i = 0; i < xyz.length; i++)if (mode.charAt(i) === 'h') {
        let A = $67c54fb1da1f0bdc$var$atan2(dy / cnt[i], dx / cnt[i]) / $67c54fb1da1f0bdc$var$PI * 180;
        while(A < 0)A += 360;
        while(A >= 360)A -= 360;
        xyz[i] = A;
    } else xyz[i] = xyz[i] / cnt[i];
    alpha /= l;
    return new (0, $e7KSJ.default)(xyz, mode).alpha(alpha > 0.99999 ? 1 : alpha, true);
};
const $67c54fb1da1f0bdc$var$_average_lrgb = (colors, weights)=>{
    const l = colors.length;
    const xyz = [
        0,
        0,
        0,
        0
    ];
    for(let i = 0; i < colors.length; i++){
        const col = colors[i];
        const f = weights[i] / l;
        const rgb = col._rgb;
        xyz[0] += $67c54fb1da1f0bdc$var$pow(rgb[0], 2) * f;
        xyz[1] += $67c54fb1da1f0bdc$var$pow(rgb[1], 2) * f;
        xyz[2] += $67c54fb1da1f0bdc$var$pow(rgb[2], 2) * f;
        xyz[3] += rgb[3] * f;
    }
    xyz[0] = $67c54fb1da1f0bdc$var$sqrt(xyz[0]);
    xyz[1] = $67c54fb1da1f0bdc$var$sqrt(xyz[1]);
    xyz[2] = $67c54fb1da1f0bdc$var$sqrt(xyz[2]);
    if (xyz[3] > 0.9999999) xyz[3] = 1;
    return new (0, $e7KSJ.default)((0, $8TO5X.default)(xyz));
};

});

parcelRegister("9u72g", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e7c5f855046555e$export$2e2bcd8739ae039);
//
// interpolates between a set of colors uzing a bezier spline
//
// @requires utils lab

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("996dd");

var $4ZQS0 = parcelRequire("4ZQS0");
// nth row of the pascal triangle
const $6e7c5f855046555e$var$binom_row = function(n) {
    let row = [
        1,
        1
    ];
    for(let i = 1; i < n; i++){
        let newrow = [
            1
        ];
        for(let j = 1; j <= row.length; j++)newrow[j] = (row[j] || 0) + row[j - 1];
        row = newrow;
    }
    return row;
};
const $6e7c5f855046555e$var$bezier = function(colors) {
    let I, lab0, lab1, lab2;
    colors = colors.map((c)=>new (0, $e7KSJ.default)(c));
    if (colors.length === 2) {
        // linear interpolation
        [lab0, lab1] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>lab0[i] + t * (lab1[i] - lab0[i]));
            return new (0, $e7KSJ.default)(lab, 'lab');
        };
    } else if (colors.length === 3) {
        // quadratic bezier interpolation
        [lab0, lab1, lab2] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>(1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i]);
            return new (0, $e7KSJ.default)(lab, 'lab');
        };
    } else if (colors.length === 4) {
        // cubic bezier interpolation
        let lab3;
        [lab0, lab1, lab2, lab3] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>(1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i]);
            return new (0, $e7KSJ.default)(lab, 'lab');
        };
    } else if (colors.length >= 5) {
        // general case (degree n bezier)
        let labs, row, n;
        labs = colors.map((c)=>c.lab());
        n = colors.length - 1;
        row = $6e7c5f855046555e$var$binom_row(n);
        I = function(t) {
            const u = 1 - t;
            const lab = [
                0,
                1,
                2
            ].map((i)=>labs.reduce((sum, el, j)=>sum + row[j] * u ** (n - j) * t ** j * el[i], 0));
            return new (0, $e7KSJ.default)(lab, 'lab');
        };
    } else throw new RangeError('No point in running bezier with only one color.');
    return I;
};
var $6e7c5f855046555e$export$2e2bcd8739ae039 = (colors)=>{
    const f = $6e7c5f855046555e$var$bezier(colors);
    f.scale = ()=>(0, $4ZQS0.default)(f);
    return f;
};

});
parcelRegister("4ZQS0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a35ded86e36da0d$export$2e2bcd8739ae039);
// minimal multi-purpose interface
// @requires utils color analyze

var $gaK1V = parcelRequire("gaK1V");
parcelRequire("i4gda");
var $gb2Ug = parcelRequire("gb2Ug");
var $hMEmV = parcelRequire("hMEmV");
const { pow: $3a35ded86e36da0d$var$pow } = Math;
function $3a35ded86e36da0d$export$2e2bcd8739ae039(colors) {
    // constructor
    let _mode = 'rgb';
    let _nacol = (0, $gaK1V.default)('#ccc');
    let _spread = 0;
    // const _fixed = false;
    let _domain = [
        0,
        1
    ];
    let _pos = [];
    let _padding = [
        0,
        0
    ];
    let _classes = false;
    let _colors = [];
    let _out = false;
    let _min = 0;
    let _max = 1;
    let _correctLightness = false;
    let _colorCache = {};
    let _useCache = true;
    let _gamma = 1;
    // private methods
    const setColors = function(colors) {
        colors = colors || [
            '#fff',
            '#000'
        ];
        if (colors && (0, $hMEmV.default)(colors) === 'string' && (0, $gaK1V.default).brewer && (0, $gaK1V.default).brewer[colors.toLowerCase()]) colors = (0, $gaK1V.default).brewer[colors.toLowerCase()];
        if ((0, $hMEmV.default)(colors) === 'array') {
            // handle single color
            if (colors.length === 1) colors = [
                colors[0],
                colors[0]
            ];
            // make a copy of the colors
            colors = colors.slice(0);
            // convert to chroma classes
            for(let c = 0; c < colors.length; c++)colors[c] = (0, $gaK1V.default)(colors[c]);
            // auto-fill color position
            _pos.length = 0;
            for(let c = 0; c < colors.length; c++)_pos.push(c / (colors.length - 1));
        }
        resetCache();
        return _colors = colors;
    };
    const getClass = function(value) {
        if (_classes != null) {
            const n = _classes.length - 1;
            let i = 0;
            while(i < n && value >= _classes[i])i++;
            return i - 1;
        }
        return 0;
    };
    let tMapLightness = (t)=>t;
    let tMapDomain = (t)=>t;
    // const classifyValue = function(value) {
    //     let val = value;
    //     if (_classes.length > 2) {
    //         const n = _classes.length-1;
    //         const i = getClass(value);
    //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
    //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
    //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
    //     }
    //     return val;
    // };
    const getColor = function(val, bypassMap) {
        let col, t;
        if (bypassMap == null) bypassMap = false;
        if (isNaN(val) || val === null) return _nacol;
        if (!bypassMap) {
            if (_classes && _classes.length > 2) {
                // find the class
                const c = getClass(val);
                t = c / (_classes.length - 2);
            } else if (_max !== _min) // just interpolate between min/max
            t = (val - _min) / (_max - _min);
            else t = 1;
        } else t = val;
        // domain map
        t = tMapDomain(t);
        if (!bypassMap) t = tMapLightness(t); // lightness correction
        if (_gamma !== 1) t = $3a35ded86e36da0d$var$pow(t, _gamma);
        t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
        t = (0, $gb2Ug.default)(t, 0, 1);
        const k = Math.floor(t * 10000);
        if (_useCache && _colorCache[k]) col = _colorCache[k];
        else {
            if ((0, $hMEmV.default)(_colors) === 'array') //for i in [0.._pos.length-1]
            for(let i = 0; i < _pos.length; i++){
                const p = _pos[i];
                if (t <= p) {
                    col = _colors[i];
                    break;
                }
                if (t >= p && i === _pos.length - 1) {
                    col = _colors[i];
                    break;
                }
                if (t > p && t < _pos[i + 1]) {
                    t = (t - p) / (_pos[i + 1] - p);
                    col = (0, $gaK1V.default).interpolate(_colors[i], _colors[i + 1], t, _mode);
                    break;
                }
            }
            else if ((0, $hMEmV.default)(_colors) === 'function') col = _colors(t);
            if (_useCache) _colorCache[k] = col;
        }
        return col;
    };
    var resetCache = ()=>_colorCache = {};
    setColors(colors);
    // public interface
    const f = function(v) {
        const c = (0, $gaK1V.default)(getColor(v));
        if (_out && c[_out]) return c[_out]();
        else return c;
    };
    f.classes = function(classes) {
        if (classes != null) {
            if ((0, $hMEmV.default)(classes) === 'array') {
                _classes = classes;
                _domain = [
                    classes[0],
                    classes[classes.length - 1]
                ];
            } else {
                const d = (0, $gaK1V.default).analyze(_domain);
                if (classes === 0) _classes = [
                    d.min,
                    d.max
                ];
                else _classes = (0, $gaK1V.default).limits(d, 'e', classes);
            }
            return f;
        }
        return _classes;
    };
    f.domain = function(domain) {
        if (!arguments.length) return _domain;
        _min = domain[0];
        _max = domain[domain.length - 1];
        _pos = [];
        const k = _colors.length;
        if (domain.length === k && _min !== _max) // update positions
        for (let d of Array.from(domain))_pos.push((d - _min) / (_max - _min));
        else {
            for(let c = 0; c < k; c++)_pos.push(c / (k - 1));
            if (domain.length > 2) {
                // set domain map
                const tOut = domain.map((d, i)=>i / (domain.length - 1));
                const tBreaks = domain.map((d)=>(d - _min) / (_max - _min));
                if (!tBreaks.every((val, i)=>tOut[i] === val)) tMapDomain = (t)=>{
                    if (t <= 0 || t >= 1) return t;
                    let i = 0;
                    while(t >= tBreaks[i + 1])i++;
                    const f = (t - tBreaks[i]) / (tBreaks[i + 1] - tBreaks[i]);
                    const out = tOut[i] + f * (tOut[i + 1] - tOut[i]);
                    return out;
                };
            }
        }
        _domain = [
            _min,
            _max
        ];
        return f;
    };
    f.mode = function(_m) {
        if (!arguments.length) return _mode;
        _mode = _m;
        resetCache();
        return f;
    };
    f.range = function(colors, _pos) {
        setColors(colors, _pos);
        return f;
    };
    f.out = function(_o) {
        _out = _o;
        return f;
    };
    f.spread = function(val) {
        if (!arguments.length) return _spread;
        _spread = val;
        return f;
    };
    f.correctLightness = function(v) {
        if (v == null) v = true;
        _correctLightness = v;
        resetCache();
        if (_correctLightness) tMapLightness = function(t) {
            const L0 = getColor(0, true).lab()[0];
            const L1 = getColor(1, true).lab()[0];
            const pol = L0 > L1;
            let L_actual = getColor(t, true).lab()[0];
            const L_ideal = L0 + (L1 - L0) * t;
            let L_diff = L_actual - L_ideal;
            let t0 = 0;
            let t1 = 1;
            let max_iter = 20;
            while(Math.abs(L_diff) > 1e-2 && max_iter-- > 0)(function() {
                if (pol) L_diff *= -1;
                if (L_diff < 0) {
                    t0 = t;
                    t += (t1 - t) * 0.5;
                } else {
                    t1 = t;
                    t += (t0 - t) * 0.5;
                }
                L_actual = getColor(t, true).lab()[0];
                return L_diff = L_actual - L_ideal;
            })();
            return t;
        };
        else tMapLightness = (t)=>t;
        return f;
    };
    f.padding = function(p) {
        if (p != null) {
            if ((0, $hMEmV.default)(p) === 'number') p = [
                p,
                p
            ];
            _padding = p;
            return f;
        } else return _padding;
    };
    f.colors = function(numColors, out) {
        // If no arguments are given, return the original colors that were provided
        if (arguments.length < 2) out = 'hex';
        let result = [];
        if (arguments.length === 0) result = _colors.slice(0);
        else if (numColors === 1) result = [
            f(0.5)
        ];
        else if (numColors > 1) {
            const dm = _domain[0];
            const dd = _domain[1] - dm;
            result = $3a35ded86e36da0d$var$__range__(0, numColors, false).map((i)=>f(dm + i / (numColors - 1) * dd));
        } else {
            // returns all colors based on the defined classes
            colors = [];
            let samples = [];
            if (_classes && _classes.length > 2) for(let i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--)samples.push((_classes[i - 1] + _classes[i]) * 0.5);
            else samples = _domain;
            result = samples.map((v)=>f(v));
        }
        if ((0, $gaK1V.default)[out]) result = result.map((c)=>c[out]());
        return result;
    };
    f.cache = function(c) {
        if (c != null) {
            _useCache = c;
            return f;
        } else return _useCache;
    };
    f.gamma = function(g) {
        if (g != null) {
            _gamma = g;
            return f;
        } else return _gamma;
    };
    f.nodata = function(d) {
        if (d != null) {
            _nacol = (0, $gaK1V.default)(d);
            return f;
        } else return _nacol;
    };
    return f;
}
function $3a35ded86e36da0d$var$__range__(left, right, inclusive) {
    let range = [];
    let ascending = left < right;
    let end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for(let i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
    return range;
}

});


parcelRegister("hKhjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceb429f3a9f3c855$export$2e2bcd8739ae039);
/*
 * interpolates between a set of colors uzing a bezier spline
 * blend mode formulas taken from https://web.archive.org/web/20180110014946/http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
 */ parcelRequire("ayOPU");

var $gaK1V = parcelRequire("gaK1V");
const $ceb429f3a9f3c855$var$blend = (bottom, top, mode)=>{
    if (!$ceb429f3a9f3c855$var$blend[mode]) throw new Error('unknown blend mode ' + mode);
    return $ceb429f3a9f3c855$var$blend[mode](bottom, top);
};
const $ceb429f3a9f3c855$var$blend_f = (f)=>(bottom, top)=>{
        const c0 = (0, $gaK1V.default)(top).rgb();
        const c1 = (0, $gaK1V.default)(bottom).rgb();
        return (0, $gaK1V.default).rgb(f(c0, c1));
    };
const $ceb429f3a9f3c855$var$each = (f)=>(c0, c1)=>{
        const out = [];
        out[0] = f(c0[0], c1[0]);
        out[1] = f(c0[1], c1[1]);
        out[2] = f(c0[2], c1[2]);
        return out;
    };
const $ceb429f3a9f3c855$var$normal = (a)=>a;
const $ceb429f3a9f3c855$var$multiply = (a, b)=>a * b / 255;
const $ceb429f3a9f3c855$var$darken = (a, b)=>a > b ? b : a;
const $ceb429f3a9f3c855$var$lighten = (a, b)=>a > b ? a : b;
const $ceb429f3a9f3c855$var$screen = (a, b)=>255 * (1 - (1 - a / 255) * (1 - b / 255));
const $ceb429f3a9f3c855$var$overlay = (a, b)=>b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
const $ceb429f3a9f3c855$var$burn = (a, b)=>255 * (1 - (1 - b / 255) / (a / 255));
const $ceb429f3a9f3c855$var$dodge = (a, b)=>{
    if (a === 255) return 255;
    a = 255 * (b / 255) / (1 - a / 255);
    return a > 255 ? 255 : a;
};
// # add = (a,b) ->
// #     if (a + b > 255) then 255 else a + b
$ceb429f3a9f3c855$var$blend.normal = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$normal));
$ceb429f3a9f3c855$var$blend.multiply = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$multiply));
$ceb429f3a9f3c855$var$blend.screen = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$screen));
$ceb429f3a9f3c855$var$blend.overlay = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$overlay));
$ceb429f3a9f3c855$var$blend.darken = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$darken));
$ceb429f3a9f3c855$var$blend.lighten = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$lighten));
$ceb429f3a9f3c855$var$blend.dodge = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$dodge));
$ceb429f3a9f3c855$var$blend.burn = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$burn));
var // blend.add = blend_f(each(add));
$ceb429f3a9f3c855$export$2e2bcd8739ae039 = $ceb429f3a9f3c855$var$blend;

});
parcelRegister("ayOPU", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");
const { round: $7b04835af4de31ed$var$round } = Math;
(0, $e7KSJ.default).prototype.rgb = function(rnd = true) {
    if (rnd === false) return this._rgb.slice(0, 3);
    return this._rgb.slice(0, 3).map($7b04835af4de31ed$var$round);
};
(0, $e7KSJ.default).prototype.rgba = function(rnd = true) {
    return this._rgb.slice(0, 4).map((v, i)=>{
        return i < 3 ? rnd === false ? v : $7b04835af4de31ed$var$round(v) : v;
    });
};
const $7b04835af4de31ed$export$8972dc0e6ad9238f = (...args)=>new (0, $e7KSJ.default)(...args, 'rgb');
Object.assign((0, $gaK1V.default), {
    rgb: $7b04835af4de31ed$export$8972dc0e6ad9238f
});
(0, $lT4NS.default).format.rgb = (...args)=>{
    const rgba = (0, $43ZPL.default)(args, 'rgba');
    if (rgba[3] === undefined) rgba[3] = 1;
    return rgba;
};
(0, $lT4NS.default).autodetect.push({
    p: 3,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'rgba');
        if ((0, $hMEmV.default)(args) === 'array' && (args.length === 3 || args.length === 4 && (0, $hMEmV.default)(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) return 'rgb';
    }
});

});


parcelRegister("jpCQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e21e7c3c7180c018$export$2e2bcd8739ae039);
// cubehelix interpolation
// based on D.A. Green "A colour scheme for the display of astronomical intensity images"
// http://astron-soc.in/bulletin/11June/289392011.pdf
parcelRequire("i4gda");
var $8TO5X = parcelRequire("8TO5X");
var $i4gda = parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $gaK1V = parcelRequire("gaK1V");
const { pow: $e21e7c3c7180c018$var$pow, sin: $e21e7c3c7180c018$var$sin, cos: $e21e7c3c7180c018$var$cos } = Math;
function $e21e7c3c7180c018$export$2e2bcd8739ae039(start = 300, rotations = -1.5, hue = 1, gamma = 1, lightness = [
    0,
    1
]) {
    let dh = 0, dl;
    if ((0, $hMEmV.default)(lightness) === 'array') dl = lightness[1] - lightness[0];
    else {
        dl = 0;
        lightness = [
            lightness,
            lightness
        ];
    }
    const f = function(fract) {
        const a = (0, $i4gda.TWOPI) * ((start + 120) / 360 + rotations * fract);
        const l = $e21e7c3c7180c018$var$pow(lightness[0] + dl * fract, gamma);
        const h = dh !== 0 ? hue[0] + fract * dh : hue;
        const amp = h * l * (1 - l) / 2;
        const cos_a = $e21e7c3c7180c018$var$cos(a);
        const sin_a = $e21e7c3c7180c018$var$sin(a);
        const r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
        const g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
        const b = l + amp * (1.97294 * cos_a);
        return (0, $gaK1V.default)((0, $8TO5X.default)([
            r * 255,
            g * 255,
            b * 255,
            1
        ]));
    };
    f.start = function(s) {
        if (s == null) return start;
        start = s;
        return f;
    };
    f.rotations = function(r) {
        if (r == null) return rotations;
        rotations = r;
        return f;
    };
    f.gamma = function(g) {
        if (g == null) return gamma;
        gamma = g;
        return f;
    };
    f.hue = function(h) {
        if (h == null) return hue;
        hue = h;
        if ((0, $hMEmV.default)(hue) === 'array') {
            dh = hue[1] - hue[0];
            if (dh === 0) hue = hue[1];
        } else dh = 0;
        return f;
    };
    f.lightness = function(h) {
        if (h == null) return lightness;
        if ((0, $hMEmV.default)(h) === 'array') {
            lightness = h;
            dl = h[1] - h[0];
        } else {
            lightness = [
                h,
                h
            ];
            dl = 0;
        }
        return f;
    };
    f.scale = ()=>(0, $gaK1V.default).scale(f);
    f.hue(hue);
    return f;
}

});

parcelRegister("eIGWI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab767cecc86e20d8$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
const $ab767cecc86e20d8$var$digits = '0123456789abcdef';
const { floor: $ab767cecc86e20d8$var$floor, random: $ab767cecc86e20d8$var$random } = Math;
var $ab767cecc86e20d8$export$2e2bcd8739ae039 = ()=>{
    let code = '#';
    for(let i = 0; i < 6; i++)code += $ab767cecc86e20d8$var$digits.charAt($ab767cecc86e20d8$var$floor($ab767cecc86e20d8$var$random() * 16));
    return new (0, $e7KSJ.default)(code, 'hex');
};

});

parcelRegister("cgHIr", function(module, exports) {

$parcel$export(module.exports, "analyze", () => $8ee8e3ba2352afc1$export$7cbcccfbecde6416);
$parcel$export(module.exports, "limits", () => $8ee8e3ba2352afc1$export$e331ca4ad6a82555);

var $hMEmV = parcelRequire("hMEmV");
const { log: $8ee8e3ba2352afc1$var$log, pow: $8ee8e3ba2352afc1$var$pow, floor: $8ee8e3ba2352afc1$var$floor, abs: $8ee8e3ba2352afc1$var$abs } = Math;
function $8ee8e3ba2352afc1$export$7cbcccfbecde6416(data, key = null) {
    const r = {
        min: Number.MAX_VALUE,
        max: Number.MAX_VALUE * -1,
        sum: 0,
        values: [],
        count: 0
    };
    if ((0, $hMEmV.default)(data) === 'object') data = Object.values(data);
    data.forEach((val)=>{
        if (key && (0, $hMEmV.default)(val) === 'object') val = val[key];
        if (val !== undefined && val !== null && !isNaN(val)) {
            r.values.push(val);
            r.sum += val;
            if (val < r.min) r.min = val;
            if (val > r.max) r.max = val;
            r.count += 1;
        }
    });
    r.domain = [
        r.min,
        r.max
    ];
    r.limits = (mode, num)=>$8ee8e3ba2352afc1$export$e331ca4ad6a82555(r, mode, num);
    return r;
}
function $8ee8e3ba2352afc1$export$e331ca4ad6a82555(data, mode = 'equal', num = 7) {
    if ((0, $hMEmV.default)(data) == 'array') data = $8ee8e3ba2352afc1$export$7cbcccfbecde6416(data);
    const { min: min, max: max } = data;
    const values = data.values.sort((a, b)=>a - b);
    if (num === 1) return [
        min,
        max
    ];
    const limits1 = [];
    if (mode.substr(0, 1) === 'c') {
        // continuous
        limits1.push(min);
        limits1.push(max);
    }
    if (mode.substr(0, 1) === 'e') {
        // equal interval
        limits1.push(min);
        for(let i = 1; i < num; i++)limits1.push(min + i / num * (max - min));
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'l') {
        // log scale
        if (min <= 0) throw new Error('Logarithmic scales are only possible for values > 0');
        const min_log = Math.LOG10E * $8ee8e3ba2352afc1$var$log(min);
        const max_log = Math.LOG10E * $8ee8e3ba2352afc1$var$log(max);
        limits1.push(min);
        for(let i = 1; i < num; i++)limits1.push($8ee8e3ba2352afc1$var$pow(10, min_log + i / num * (max_log - min_log)));
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'q') {
        // quantile scale
        limits1.push(min);
        for(let i = 1; i < num; i++){
            const p = (values.length - 1) * i / num;
            const pb = $8ee8e3ba2352afc1$var$floor(p);
            if (pb === p) limits1.push(values[pb]);
            else {
                // p > pb
                const pr = p - pb;
                limits1.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
            }
        }
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'k') {
        // k-means clustering
        /*
        implementation based on
        http://code.google.com/p/figue/source/browse/trunk/figue.js#336
        simplified for 1-d input values
        */ let cluster;
        const n = values.length;
        const assignments = new Array(n);
        const clusterSizes = new Array(num);
        let repeat = true;
        let nb_iters = 0;
        let centroids = null;
        // get seed values
        centroids = [];
        centroids.push(min);
        for(let i = 1; i < num; i++)centroids.push(min + i / num * (max - min));
        centroids.push(max);
        while(repeat){
            // assignment step
            for(let j = 0; j < num; j++)clusterSizes[j] = 0;
            for(let i = 0; i < n; i++){
                const value = values[i];
                let mindist = Number.MAX_VALUE;
                let best;
                for(let j = 0; j < num; j++){
                    const dist = $8ee8e3ba2352afc1$var$abs(centroids[j] - value);
                    if (dist < mindist) {
                        mindist = dist;
                        best = j;
                    }
                    clusterSizes[best]++;
                    assignments[i] = best;
                }
            }
            // update centroids step
            const newCentroids = new Array(num);
            for(let j = 0; j < num; j++)newCentroids[j] = null;
            for(let i = 0; i < n; i++){
                cluster = assignments[i];
                if (newCentroids[cluster] === null) newCentroids[cluster] = values[i];
                else newCentroids[cluster] += values[i];
            }
            for(let j = 0; j < num; j++)newCentroids[j] *= 1 / clusterSizes[j];
            // check convergence
            repeat = false;
            for(let j = 0; j < num; j++)if (newCentroids[j] !== centroids[j]) {
                repeat = true;
                break;
            }
            centroids = newCentroids;
            nb_iters++;
            if (nb_iters > 200) repeat = false;
        }
        // finished k-means clustering
        // the next part is borrowed from gabrielflor.it
        const kClusters = {};
        for(let j = 0; j < num; j++)kClusters[j] = [];
        for(let i = 0; i < n; i++){
            cluster = assignments[i];
            kClusters[cluster].push(values[i]);
        }
        let tmpKMeansBreaks = [];
        for(let j = 0; j < num; j++){
            tmpKMeansBreaks.push(kClusters[j][0]);
            tmpKMeansBreaks.push(kClusters[j][kClusters[j].length - 1]);
        }
        tmpKMeansBreaks = tmpKMeansBreaks.sort((a, b)=>a - b);
        limits1.push(tmpKMeansBreaks[0]);
        for(let i = 1; i < tmpKMeansBreaks.length; i += 2){
            const v = tmpKMeansBreaks[i];
            if (!isNaN(v) && limits1.indexOf(v) === -1) limits1.push(v);
        }
    }
    return limits1;
}

});

parcelRegister("5BDZu", function(module, exports) {

$parcel$export(module.exports, "default", () => $414f6dca23b2a9de$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("hDPZe");
var $414f6dca23b2a9de$export$2e2bcd8739ae039 = (a, b)=>{
    // WCAG contrast ratio
    // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
    a = new (0, $e7KSJ.default)(a);
    b = new (0, $e7KSJ.default)(b);
    const l1 = a.luminance();
    const l2 = b.luminance();
    return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
};

});

parcelRegister("iM4ga", function(module, exports) {

$parcel$export(module.exports, "default", () => $dab003980244b19f$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");

var $dvq8W = parcelRequire("dvq8W");
/**
 * @license
 *
 * The APCA contrast prediction algorithm is based of the formulas published
 * in the APCA-1.0.98G specification by Myndex. The specification is available at:
 * https://raw.githubusercontent.com/Myndex/apca-w3/master/images/APCAw3_0.1.17_APCA0.0.98G.svg
 *
 * Note that the APCA implementation is still beta, so please update to
 * future versions of chroma.js when they become available.
 *
 * You can read more about the APCA Readability Criterion at
 * https://readtech.org/ARC/
 */ // constants
const $dab003980244b19f$var$W_offset = 0.027;
const $dab003980244b19f$var$P_in = 0.0005;
const $dab003980244b19f$var$P_out = 0.1;
const $dab003980244b19f$var$R_scale = 1.14;
const $dab003980244b19f$var$B_threshold = 0.022;
const $dab003980244b19f$var$B_exp = 1.414;
var $dab003980244b19f$export$2e2bcd8739ae039 = (text, bg)=>{
    // parse input colors
    text = new (0, $e7KSJ.default)(text);
    bg = new (0, $e7KSJ.default)(bg);
    // if text color has alpha, blend against background
    if (text.alpha() < 1) text = (0, $dvq8W.default)(bg, text, text.alpha(), 'rgb');
    const l_text = $dab003980244b19f$var$lum(...text.rgb());
    const l_bg = $dab003980244b19f$var$lum(...bg.rgb());
    // soft clamp black levels
    const Y_text = l_text >= $dab003980244b19f$var$B_threshold ? l_text : l_text + Math.pow($dab003980244b19f$var$B_threshold - l_text, $dab003980244b19f$var$B_exp);
    const Y_bg = l_bg >= $dab003980244b19f$var$B_threshold ? l_bg : l_bg + Math.pow($dab003980244b19f$var$B_threshold - l_bg, $dab003980244b19f$var$B_exp);
    // normal polarity (dark text on light background)
    const S_norm = Math.pow(Y_bg, 0.56) - Math.pow(Y_text, 0.57);
    // reverse polarity (light text on dark background)
    const S_rev = Math.pow(Y_bg, 0.65) - Math.pow(Y_text, 0.62);
    // clamp noise then scale
    const C = Math.abs(Y_bg - Y_text) < $dab003980244b19f$var$P_in ? 0 : Y_text < Y_bg ? S_norm * $dab003980244b19f$var$R_scale : S_rev * $dab003980244b19f$var$R_scale;
    // clamp minimum contrast then offset
    const S_apc = Math.abs(C) < $dab003980244b19f$var$P_out ? 0 : C > 0 ? C - $dab003980244b19f$var$W_offset : C + $dab003980244b19f$var$W_offset;
    // scale to 100
    return S_apc * 100;
};
function $dab003980244b19f$var$lum(r, g, b) {
    return 0.2126729 * Math.pow(r / 255, 2.4) + 0.7151522 * Math.pow(g / 255, 2.4) + 0.072175 * Math.pow(b / 255, 2.4);
}

});

parcelRegister("xkLDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $064331241a6f3932$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
const { sqrt: $064331241a6f3932$var$sqrt, pow: $064331241a6f3932$var$pow, min: $064331241a6f3932$var$min, max: $064331241a6f3932$var$max, atan2: $064331241a6f3932$var$atan2, abs: $064331241a6f3932$var$abs, cos: $064331241a6f3932$var$cos, sin: $064331241a6f3932$var$sin, exp: $064331241a6f3932$var$exp, PI: $064331241a6f3932$var$PI } = Math;
function $064331241a6f3932$export$2e2bcd8739ae039(a, b, Kl = 1, Kc = 1, Kh = 1) {
    // Delta E (CIE 2000)
    // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CIE2000.html
    var rad2deg = function(rad) {
        return 360 * rad / (2 * $064331241a6f3932$var$PI);
    };
    var deg2rad = function(deg) {
        return 2 * $064331241a6f3932$var$PI * deg / 360;
    };
    a = new (0, $e7KSJ.default)(a);
    b = new (0, $e7KSJ.default)(b);
    const [L1, a1, b1] = Array.from(a.lab());
    const [L2, a2, b2] = Array.from(b.lab());
    const avgL = (L1 + L2) / 2;
    const C1 = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(a1, 2) + $064331241a6f3932$var$pow(b1, 2));
    const C2 = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(a2, 2) + $064331241a6f3932$var$pow(b2, 2));
    const avgC = (C1 + C2) / 2;
    const G = 0.5 * (1 - $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(avgC, 7) / ($064331241a6f3932$var$pow(avgC, 7) + $064331241a6f3932$var$pow(25, 7))));
    const a1p = a1 * (1 + G);
    const a2p = a2 * (1 + G);
    const C1p = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(a1p, 2) + $064331241a6f3932$var$pow(b1, 2));
    const C2p = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(a2p, 2) + $064331241a6f3932$var$pow(b2, 2));
    const avgCp = (C1p + C2p) / 2;
    const arctan1 = rad2deg($064331241a6f3932$var$atan2(b1, a1p));
    const arctan2 = rad2deg($064331241a6f3932$var$atan2(b2, a2p));
    const h1p = arctan1 >= 0 ? arctan1 : arctan1 + 360;
    const h2p = arctan2 >= 0 ? arctan2 : arctan2 + 360;
    const avgHp = $064331241a6f3932$var$abs(h1p - h2p) > 180 ? (h1p + h2p + 360) / 2 : (h1p + h2p) / 2;
    const T = 1 - 0.17 * $064331241a6f3932$var$cos(deg2rad(avgHp - 30)) + 0.24 * $064331241a6f3932$var$cos(deg2rad(2 * avgHp)) + 0.32 * $064331241a6f3932$var$cos(deg2rad(3 * avgHp + 6)) - 0.2 * $064331241a6f3932$var$cos(deg2rad(4 * avgHp - 63));
    let deltaHp = h2p - h1p;
    deltaHp = $064331241a6f3932$var$abs(deltaHp) <= 180 ? deltaHp : h2p <= h1p ? deltaHp + 360 : deltaHp - 360;
    deltaHp = 2 * $064331241a6f3932$var$sqrt(C1p * C2p) * $064331241a6f3932$var$sin(deg2rad(deltaHp) / 2);
    const deltaL = L2 - L1;
    const deltaCp = C2p - C1p;
    const sl = 1 + 0.015 * $064331241a6f3932$var$pow(avgL - 50, 2) / $064331241a6f3932$var$sqrt(20 + $064331241a6f3932$var$pow(avgL - 50, 2));
    const sc = 1 + 0.045 * avgCp;
    const sh = 1 + 0.015 * avgCp * T;
    const deltaTheta = 30 * $064331241a6f3932$var$exp(-$064331241a6f3932$var$pow((avgHp - 275) / 25, 2));
    const Rc = 2 * $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(avgCp, 7) / ($064331241a6f3932$var$pow(avgCp, 7) + $064331241a6f3932$var$pow(25, 7)));
    const Rt = -Rc * $064331241a6f3932$var$sin(2 * deg2rad(deltaTheta));
    const result = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(deltaL / (Kl * sl), 2) + $064331241a6f3932$var$pow(deltaCp / (Kc * sc), 2) + $064331241a6f3932$var$pow(deltaHp / (Kh * sh), 2) + Rt * (deltaCp / (Kc * sc)) * (deltaHp / (Kh * sh)));
    return $064331241a6f3932$var$max(0, $064331241a6f3932$var$min(100, result));
}

});

parcelRegister("iB6ta", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8a0b365443a1f76$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
function $d8a0b365443a1f76$export$2e2bcd8739ae039(a, b, mode = 'lab') {
    // Delta E (CIE 1976)
    // see http://www.brucelindbloom.com/index.html?Equations.html
    a = new (0, $e7KSJ.default)(a);
    b = new (0, $e7KSJ.default)(b);
    const l1 = a.get(mode);
    const l2 = b.get(mode);
    let sum_sq = 0;
    for(let i in l1){
        const d = (l1[i] || 0) - (l2[i] || 0);
        sum_sq += d * d;
    }
    return Math.sqrt(sum_sq);
}

});

parcelRegister("dID0y", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fcda4939aef1ea4$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
var $9fcda4939aef1ea4$export$2e2bcd8739ae039 = (...args)=>{
    try {
        new (0, $e7KSJ.default)(...args);
        return true;
    // eslint-disable-next-line
    } catch (e) {
        return false;
    }
};

});

parcelRegister("1vtEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $118fb0138dc62de8$export$2e2bcd8739ae039);
// some pre-defined color scales:

var $gaK1V = parcelRequire("gaK1V");
parcelRequire("fbI2I");

var $4ZQS0 = parcelRequire("4ZQS0");
var $118fb0138dc62de8$export$2e2bcd8739ae039 = {
    cool () {
        return (0, $4ZQS0.default)([
            (0, $gaK1V.default).hsl(180, 1, 0.9),
            (0, $gaK1V.default).hsl(250, 0.7, 0.4)
        ]);
    },
    hot () {
        return (0, $4ZQS0.default)([
            '#000',
            '#f00',
            '#ff0',
            '#fff'
        ], [
            0,
            0.25,
            0.75,
            1
        ]).mode('rgb');
    }
};

});

parcelRegister("6Sny4", function(module, exports) {

$parcel$export(module.exports, "default", () => $501a0d7a311e121c$export$2e2bcd8739ae039);
/**
    ColorBrewer colors for chroma.js

    Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
    Pennsylvania State University.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at
    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software distributed
    under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
    CONDITIONS OF ANY KIND, either express or implied. See the License for the
    specific language governing permissions and limitations under the License.
*/ const $501a0d7a311e121c$var$colorbrewer = {
    // sequential
    OrRd: [
        '#fff7ec',
        '#fee8c8',
        '#fdd49e',
        '#fdbb84',
        '#fc8d59',
        '#ef6548',
        '#d7301f',
        '#b30000',
        '#7f0000'
    ],
    PuBu: [
        '#fff7fb',
        '#ece7f2',
        '#d0d1e6',
        '#a6bddb',
        '#74a9cf',
        '#3690c0',
        '#0570b0',
        '#045a8d',
        '#023858'
    ],
    BuPu: [
        '#f7fcfd',
        '#e0ecf4',
        '#bfd3e6',
        '#9ebcda',
        '#8c96c6',
        '#8c6bb1',
        '#88419d',
        '#810f7c',
        '#4d004b'
    ],
    Oranges: [
        '#fff5eb',
        '#fee6ce',
        '#fdd0a2',
        '#fdae6b',
        '#fd8d3c',
        '#f16913',
        '#d94801',
        '#a63603',
        '#7f2704'
    ],
    BuGn: [
        '#f7fcfd',
        '#e5f5f9',
        '#ccece6',
        '#99d8c9',
        '#66c2a4',
        '#41ae76',
        '#238b45',
        '#006d2c',
        '#00441b'
    ],
    YlOrBr: [
        '#ffffe5',
        '#fff7bc',
        '#fee391',
        '#fec44f',
        '#fe9929',
        '#ec7014',
        '#cc4c02',
        '#993404',
        '#662506'
    ],
    YlGn: [
        '#ffffe5',
        '#f7fcb9',
        '#d9f0a3',
        '#addd8e',
        '#78c679',
        '#41ab5d',
        '#238443',
        '#006837',
        '#004529'
    ],
    Reds: [
        '#fff5f0',
        '#fee0d2',
        '#fcbba1',
        '#fc9272',
        '#fb6a4a',
        '#ef3b2c',
        '#cb181d',
        '#a50f15',
        '#67000d'
    ],
    RdPu: [
        '#fff7f3',
        '#fde0dd',
        '#fcc5c0',
        '#fa9fb5',
        '#f768a1',
        '#dd3497',
        '#ae017e',
        '#7a0177',
        '#49006a'
    ],
    Greens: [
        '#f7fcf5',
        '#e5f5e0',
        '#c7e9c0',
        '#a1d99b',
        '#74c476',
        '#41ab5d',
        '#238b45',
        '#006d2c',
        '#00441b'
    ],
    YlGnBu: [
        '#ffffd9',
        '#edf8b1',
        '#c7e9b4',
        '#7fcdbb',
        '#41b6c4',
        '#1d91c0',
        '#225ea8',
        '#253494',
        '#081d58'
    ],
    Purples: [
        '#fcfbfd',
        '#efedf5',
        '#dadaeb',
        '#bcbddc',
        '#9e9ac8',
        '#807dba',
        '#6a51a3',
        '#54278f',
        '#3f007d'
    ],
    GnBu: [
        '#f7fcf0',
        '#e0f3db',
        '#ccebc5',
        '#a8ddb5',
        '#7bccc4',
        '#4eb3d3',
        '#2b8cbe',
        '#0868ac',
        '#084081'
    ],
    Greys: [
        '#ffffff',
        '#f0f0f0',
        '#d9d9d9',
        '#bdbdbd',
        '#969696',
        '#737373',
        '#525252',
        '#252525',
        '#000000'
    ],
    YlOrRd: [
        '#ffffcc',
        '#ffeda0',
        '#fed976',
        '#feb24c',
        '#fd8d3c',
        '#fc4e2a',
        '#e31a1c',
        '#bd0026',
        '#800026'
    ],
    PuRd: [
        '#f7f4f9',
        '#e7e1ef',
        '#d4b9da',
        '#c994c7',
        '#df65b0',
        '#e7298a',
        '#ce1256',
        '#980043',
        '#67001f'
    ],
    Blues: [
        '#f7fbff',
        '#deebf7',
        '#c6dbef',
        '#9ecae1',
        '#6baed6',
        '#4292c6',
        '#2171b5',
        '#08519c',
        '#08306b'
    ],
    PuBuGn: [
        '#fff7fb',
        '#ece2f0',
        '#d0d1e6',
        '#a6bddb',
        '#67a9cf',
        '#3690c0',
        '#02818a',
        '#016c59',
        '#014636'
    ],
    Viridis: [
        '#440154',
        '#482777',
        '#3f4a8a',
        '#31678e',
        '#26838f',
        '#1f9d8a',
        '#6cce5a',
        '#b6de2b',
        '#fee825'
    ],
    // diverging
    Spectral: [
        '#9e0142',
        '#d53e4f',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#e6f598',
        '#abdda4',
        '#66c2a5',
        '#3288bd',
        '#5e4fa2'
    ],
    RdYlGn: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#d9ef8b',
        '#a6d96a',
        '#66bd63',
        '#1a9850',
        '#006837'
    ],
    RdBu: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#f7f7f7',
        '#d1e5f0',
        '#92c5de',
        '#4393c3',
        '#2166ac',
        '#053061'
    ],
    PiYG: [
        '#8e0152',
        '#c51b7d',
        '#de77ae',
        '#f1b6da',
        '#fde0ef',
        '#f7f7f7',
        '#e6f5d0',
        '#b8e186',
        '#7fbc41',
        '#4d9221',
        '#276419'
    ],
    PRGn: [
        '#40004b',
        '#762a83',
        '#9970ab',
        '#c2a5cf',
        '#e7d4e8',
        '#f7f7f7',
        '#d9f0d3',
        '#a6dba0',
        '#5aae61',
        '#1b7837',
        '#00441b'
    ],
    RdYlBu: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee090',
        '#ffffbf',
        '#e0f3f8',
        '#abd9e9',
        '#74add1',
        '#4575b4',
        '#313695'
    ],
    BrBG: [
        '#543005',
        '#8c510a',
        '#bf812d',
        '#dfc27d',
        '#f6e8c3',
        '#f5f5f5',
        '#c7eae5',
        '#80cdc1',
        '#35978f',
        '#01665e',
        '#003c30'
    ],
    RdGy: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#ffffff',
        '#e0e0e0',
        '#bababa',
        '#878787',
        '#4d4d4d',
        '#1a1a1a'
    ],
    PuOr: [
        '#7f3b08',
        '#b35806',
        '#e08214',
        '#fdb863',
        '#fee0b6',
        '#f7f7f7',
        '#d8daeb',
        '#b2abd2',
        '#8073ac',
        '#542788',
        '#2d004b'
    ],
    // qualitative
    Set2: [
        '#66c2a5',
        '#fc8d62',
        '#8da0cb',
        '#e78ac3',
        '#a6d854',
        '#ffd92f',
        '#e5c494',
        '#b3b3b3'
    ],
    Accent: [
        '#7fc97f',
        '#beaed4',
        '#fdc086',
        '#ffff99',
        '#386cb0',
        '#f0027f',
        '#bf5b17',
        '#666666'
    ],
    Set1: [
        '#e41a1c',
        '#377eb8',
        '#4daf4a',
        '#984ea3',
        '#ff7f00',
        '#ffff33',
        '#a65628',
        '#f781bf',
        '#999999'
    ],
    Set3: [
        '#8dd3c7',
        '#ffffb3',
        '#bebada',
        '#fb8072',
        '#80b1d3',
        '#fdb462',
        '#b3de69',
        '#fccde5',
        '#d9d9d9',
        '#bc80bd',
        '#ccebc5',
        '#ffed6f'
    ],
    Dark2: [
        '#1b9e77',
        '#d95f02',
        '#7570b3',
        '#e7298a',
        '#66a61e',
        '#e6ab02',
        '#a6761d',
        '#666666'
    ],
    Paired: [
        '#a6cee3',
        '#1f78b4',
        '#b2df8a',
        '#33a02c',
        '#fb9a99',
        '#e31a1c',
        '#fdbf6f',
        '#ff7f00',
        '#cab2d6',
        '#6a3d9a',
        '#ffff99',
        '#b15928'
    ],
    Pastel2: [
        '#b3e2cd',
        '#fdcdac',
        '#cbd5e8',
        '#f4cae4',
        '#e6f5c9',
        '#fff2ae',
        '#f1e2cc',
        '#cccccc'
    ],
    Pastel1: [
        '#fbb4ae',
        '#b3cde3',
        '#ccebc5',
        '#decbe4',
        '#fed9a6',
        '#ffffcc',
        '#e5d8bd',
        '#fddaec',
        '#f2f2f2'
    ]
};
const $501a0d7a311e121c$var$colorbrewerTypes = Object.keys($501a0d7a311e121c$var$colorbrewer);
const $501a0d7a311e121c$var$typeMap = new Map($501a0d7a311e121c$var$colorbrewerTypes.map((key)=>[
        key.toLowerCase(),
        key
    ]));
// use Proxy to allow case-insensitive access to palettes
const $501a0d7a311e121c$var$colorbrewerProxy = typeof Proxy === 'function' ? new Proxy($501a0d7a311e121c$var$colorbrewer, {
    get (target, prop) {
        const lower = prop.toLowerCase();
        if ($501a0d7a311e121c$var$typeMap.has(lower)) return target[$501a0d7a311e121c$var$typeMap.get(lower)];
    },
    getOwnPropertyNames () {
        return Object.getOwnPropertyNames($501a0d7a311e121c$var$colorbrewerTypes);
    }
}) : $501a0d7a311e121c$var$colorbrewer;
var $501a0d7a311e121c$export$2e2bcd8739ae039 = $501a0d7a311e121c$var$colorbrewerProxy;

});

parcelRegister("7hd9c", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $jKxIE = parcelRequire("jKxIE");

var $2o2Lo = parcelRequire("2o2Lo");
(0, $e7KSJ.default).prototype.cmyk = function() {
    return (0, $2o2Lo.default)(this._rgb);
};
const $54c451bcc042ac64$export$358b1a66a3c77756 = (...args)=>new (0, $e7KSJ.default)(...args, 'cmyk');
Object.assign((0, $gaK1V.default), {
    cmyk: $54c451bcc042ac64$export$358b1a66a3c77756
});
(0, $lT4NS.default).format.cmyk = (0, $jKxIE.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'cmyk');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 4) return 'cmyk';
    }
});

});
parcelRegister("jKxIE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e60c7822c37b0c25$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $e60c7822c37b0c25$var$cmyk2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'cmyk');
    const [c, m, y, k] = args;
    const alpha = args.length > 4 ? args[4] : 1;
    if (k === 1) return [
        0,
        0,
        0,
        alpha
    ];
    return [
        c >= 1 ? 0 : 255 * (1 - c) * (1 - k),
        m >= 1 ? 0 : 255 * (1 - m) * (1 - k),
        y >= 1 ? 0 : 255 * (1 - y) * (1 - k),
        alpha
    ];
};
var $e60c7822c37b0c25$export$2e2bcd8739ae039 = $e60c7822c37b0c25$var$cmyk2rgb;

});

parcelRegister("2o2Lo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bcff769908141f5$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { max: $1bcff769908141f5$var$max } = Math;
const $1bcff769908141f5$var$rgb2cmyk = (...args)=>{
    let [r, g, b] = (0, $43ZPL.default)(args, 'rgb');
    r = r / 255;
    g = g / 255;
    b = b / 255;
    const k = 1 - $1bcff769908141f5$var$max(r, $1bcff769908141f5$var$max(g, b));
    const f = k < 1 ? 1 / (1 - k) : 0;
    const c = (1 - r - k) * f;
    const m = (1 - g - k) * f;
    const y = (1 - b - k) * f;
    return [
        c,
        m,
        y,
        k
    ];
};
var $1bcff769908141f5$export$2e2bcd8739ae039 = $1bcff769908141f5$var$rgb2cmyk;

});


parcelRegister("cIiSk", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $iwUkC = parcelRequire("iwUkC");

var $lmq0O = parcelRequire("lmq0O");
(0, $e7KSJ.default).prototype.css = function(mode) {
    return (0, $iwUkC.default)(this._rgb, mode);
};
const $94183c5a55123dcc$export$dbf350e5966cf602 = (...args)=>new (0, $e7KSJ.default)(...args, 'css');
(0, $gaK1V.default).css = $94183c5a55123dcc$export$dbf350e5966cf602;
(0, $lT4NS.default).format.css = (0, $lmq0O.default);
(0, $lT4NS.default).autodetect.push({
    p: 5,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $hMEmV.default)(h) === 'string' && (0, $lmq0O.default).test(h)) return 'css';
    }
});

});
parcelRegister("iwUkC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7d6e97251c964b7$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $43ZPL = parcelRequire("43ZPL");

var $8r7If = parcelRequire("8r7If");

var $f9fTr = parcelRequire("f9fTr");

var $6Sszj = parcelRequire("6Sszj");

var $luvnN = parcelRequire("luvnN");

var $c020c = parcelRequire("c020c");

var $jSfgf = parcelRequire("jSfgf");

var $eJb2q = parcelRequire("eJb2q");

var $5KW7E = parcelRequire("5KW7E");

var $855Nw = parcelRequire("855Nw");

var $a0o1I = parcelRequire("a0o1I");

var $8weUB = parcelRequire("8weUB");
const { round: $d7d6e97251c964b7$var$round } = Math;
/*
 * supported arguments:
 * - rgb2css(r,g,b)
 * - rgb2css(r,g,b,a)
 * - rgb2css([r,g,b], mode)
 * - rgb2css([r,g,b,a], mode)
 * - rgb2css({r,g,b,a}, mode)
 */ const $d7d6e97251c964b7$var$rgb2css = (...args)=>{
    const rgba = (0, $43ZPL.default)(args, 'rgba');
    let mode = (0, $7ElX1.default)(args) || 'rgb';
    if (mode.substr(0, 3) === 'hsl') return (0, $8r7If.default)((0, $f9fTr.default)(rgba), mode);
    if (mode.substr(0, 3) === 'lab') {
        // change to D50 lab whitepoint since this is what W3C is using for CSS Lab colors
        const prevWhitePoint = (0, $8weUB.getLabWhitePoint)();
        (0, $8weUB.setLabWhitePoint)('d50');
        const cssColor = (0, $6Sszj.default)((0, $luvnN.default)(rgba), mode);
        (0, $8weUB.setLabWhitePoint)(prevWhitePoint);
        return cssColor;
    }
    if (mode.substr(0, 3) === 'lch') {
        // change to D50 lab whitepoint since this is what W3C is using for CSS Lab colors
        const prevWhitePoint = (0, $8weUB.getLabWhitePoint)();
        (0, $8weUB.setLabWhitePoint)('d50');
        const cssColor = (0, $c020c.default)((0, $jSfgf.default)(rgba), mode);
        (0, $8weUB.setLabWhitePoint)(prevWhitePoint);
        return cssColor;
    }
    if (mode.substr(0, 5) === 'oklab') return (0, $5KW7E.default)((0, $eJb2q.default)(rgba));
    if (mode.substr(0, 5) === 'oklch') return (0, $a0o1I.default)((0, $855Nw.default)(rgba));
    rgba[0] = $d7d6e97251c964b7$var$round(rgba[0]);
    rgba[1] = $d7d6e97251c964b7$var$round(rgba[1]);
    rgba[2] = $d7d6e97251c964b7$var$round(rgba[2]);
    if (mode === 'rgba' || rgba.length > 3 && rgba[3] < 1) {
        rgba[3] = '/ ' + (rgba.length > 3 ? rgba[3] : 1);
        mode = 'rgba';
    }
    return `${mode.substr(0, 3)}(${rgba.slice(0, mode === 'rgb' ? 3 : 4).join(' ')})`;
};
var $d7d6e97251c964b7$export$2e2bcd8739ae039 = $d7d6e97251c964b7$var$rgb2css;

});
parcelRegister("8r7If", function(module, exports) {

$parcel$export(module.exports, "default", () => $6246d3ee765f7d54$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * supported arguments:
 * - hsl2css(h,s,l)
 * - hsl2css(h,s,l,a)
 * - hsl2css([h,s,l], mode)
 * - hsl2css([h,s,l,a], mode)
 * - hsl2css({h,s,l,a}, mode)
 */ const $6246d3ee765f7d54$var$hsl2css = (...args)=>{
    const hsla = (0, $43ZPL.default)(args, 'hsla');
    let mode = (0, $7ElX1.default)(args) || 'lsa';
    hsla[0] = (0, $i4gda.rnd2)(hsla[0] || 0) + 'deg';
    hsla[1] = (0, $i4gda.rnd2)(hsla[1] * 100) + '%';
    hsla[2] = (0, $i4gda.rnd2)(hsla[2] * 100) + '%';
    if (mode === 'hsla' || hsla.length > 3 && hsla[3] < 1) {
        hsla[3] = '/ ' + (hsla.length > 3 ? hsla[3] : 1);
        mode = 'hsla';
    } else hsla.length = 3;
    return `${mode.substr(0, 3)}(${hsla.join(' ')})`;
};
var $6246d3ee765f7d54$export$2e2bcd8739ae039 = $6246d3ee765f7d54$var$hsl2css;

});

parcelRegister("6Sszj", function(module, exports) {

$parcel$export(module.exports, "default", () => $501df25942503107$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * supported arguments:
 * - lab2css(l,a,b)
 * - lab2css(l,a,b,alpha)
 * - lab2css([l,a,b], mode)
 * - lab2css([l,a,b,alpha], mode)
 */ const $501df25942503107$var$lab2css = (...args)=>{
    const laba = (0, $43ZPL.default)(args, 'lab');
    let mode = (0, $7ElX1.default)(args) || 'lab';
    laba[0] = (0, $i4gda.rnd2)(laba[0]) + '%';
    laba[1] = (0, $i4gda.rnd2)(laba[1]);
    laba[2] = (0, $i4gda.rnd2)(laba[2]);
    if (mode === 'laba' || laba.length > 3 && laba[3] < 1) laba[3] = '/ ' + (laba.length > 3 ? laba[3] : 1);
    else laba.length = 3;
    return `lab(${laba.join(' ')})`;
};
var $501df25942503107$export$2e2bcd8739ae039 = $501df25942503107$var$lab2css;

});

parcelRegister("c020c", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc709b6cfda3284$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * supported arguments:
 * - lab2css(l,a,b)
 * - lab2css(l,a,b,alpha)
 * - lab2css([l,a,b], mode)
 * - lab2css([l,a,b,alpha], mode)
 */ const $8bc709b6cfda3284$var$lch2css = (...args)=>{
    const lcha = (0, $43ZPL.default)(args, 'lch');
    let mode = (0, $7ElX1.default)(args) || 'lab';
    lcha[0] = (0, $i4gda.rnd2)(lcha[0]) + '%';
    lcha[1] = (0, $i4gda.rnd2)(lcha[1]);
    lcha[2] = isNaN(lcha[2]) ? 'none' : (0, $i4gda.rnd2)(lcha[2]) + 'deg'; // add deg unit to hue
    if (mode === 'lcha' || lcha.length > 3 && lcha[3] < 1) lcha[3] = '/ ' + (lcha.length > 3 ? lcha[3] : 1);
    else lcha.length = 3;
    return `lch(${lcha.join(' ')})`;
};
var $8bc709b6cfda3284$export$2e2bcd8739ae039 = $8bc709b6cfda3284$var$lch2css;

});

parcelRegister("5KW7E", function(module, exports) {

$parcel$export(module.exports, "default", () => $430e55826084c20e$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $430e55826084c20e$var$oklab2css = (...args)=>{
    const laba = (0, $43ZPL.default)(args, 'lab');
    laba[0] = (0, $i4gda.rnd2)(laba[0] * 100) + '%';
    laba[1] = (0, $i4gda.rnd3)(laba[1]);
    laba[2] = (0, $i4gda.rnd3)(laba[2]);
    if (laba.length > 3 && laba[3] < 1) laba[3] = '/ ' + (laba.length > 3 ? laba[3] : 1);
    else laba.length = 3;
    return `oklab(${laba.join(' ')})`;
};
var $430e55826084c20e$export$2e2bcd8739ae039 = $430e55826084c20e$var$oklab2css;

});

parcelRegister("855Nw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e2349b11f40bce3$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $eJb2q = parcelRequire("eJb2q");

var $36WLn = parcelRequire("36WLn");
const $5e2349b11f40bce3$var$rgb2oklch = (...args)=>{
    const [r, g, b, ...rest] = (0, $43ZPL.default)(args, 'rgb');
    const [l, a, b_] = (0, $eJb2q.default)(r, g, b);
    const [L, c, h] = (0, $36WLn.default)(l, a, b_);
    return [
        L,
        c,
        h,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $5e2349b11f40bce3$export$2e2bcd8739ae039 = $5e2349b11f40bce3$var$rgb2oklch;

});

parcelRegister("a0o1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $748c8aa705dcdecb$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $748c8aa705dcdecb$var$oklch2css = (...args)=>{
    const lcha = (0, $43ZPL.default)(args, 'lch');
    lcha[0] = (0, $i4gda.rnd2)(lcha[0] * 100) + '%';
    lcha[1] = (0, $i4gda.rnd3)(lcha[1]);
    lcha[2] = isNaN(lcha[2]) ? 'none' : (0, $i4gda.rnd2)(lcha[2]) + 'deg'; // add deg unit to hue
    if (lcha.length > 3 && lcha[3] < 1) lcha[3] = '/ ' + (lcha.length > 3 ? lcha[3] : 1);
    else lcha.length = 3;
    return `oklch(${lcha.join(' ')})`;
};
var $748c8aa705dcdecb$export$2e2bcd8739ae039 = $748c8aa705dcdecb$var$oklch2css;

});


parcelRegister("lmq0O", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8cfd480aa486045$export$2e2bcd8739ae039);

var $7PGtI = parcelRequire("7PGtI");

var $jenZn = parcelRequire("jenZn");

var $g4jd5 = parcelRequire("g4jd5");

var $5D4bx = parcelRequire("5D4bx");

var $9cCPH = parcelRequire("9cCPH");

var $lT4NS = parcelRequire("lT4NS");

var $gb2Ug = parcelRequire("gb2Ug");

var $8weUB = parcelRequire("8weUB");
const $f8cfd480aa486045$var$INT_OR_PCT = /((?:-?\d+)|(?:-?\d+(?:\.\d+)?)%|none)/.source;
const $f8cfd480aa486045$var$FLOAT_OR_PCT = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%?)|none)/.source;
const $f8cfd480aa486045$var$PCT = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%)|none)/.source;
const $f8cfd480aa486045$var$RE_S = /\s*/.source;
const $f8cfd480aa486045$var$SEP = /\s+/.source;
const $f8cfd480aa486045$var$COMMA = /\s*,\s*/.source;
const $f8cfd480aa486045$var$ANLGE = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)(?:deg)?)|none)/.source;
const $f8cfd480aa486045$var$ALPHA = /\s*(?:\/\s*((?:[01]|[01]?\.\d+)|\d+(?:\.\d+)?%))?/.source;
// e.g. rgb(250 20 0), rgb(100% 50% 20%), rgb(100% 50% 20% / 0.5)
const $f8cfd480aa486045$var$RE_RGB = new RegExp('^rgba?\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_RGB_LEGACY = new RegExp('^rgb\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT
].join($f8cfd480aa486045$var$COMMA) + $f8cfd480aa486045$var$RE_S + '\\)$');
const $f8cfd480aa486045$var$RE_RGBA_LEGACY = new RegExp('^rgba\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT
].join($f8cfd480aa486045$var$COMMA) + $f8cfd480aa486045$var$RE_S + '\\)$');
const $f8cfd480aa486045$var$RE_HSL = new RegExp('^hsla?\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$ANLGE,
    $f8cfd480aa486045$var$PCT,
    $f8cfd480aa486045$var$PCT
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_HSL_LEGACY = new RegExp('^hsl?\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$ANLGE,
    $f8cfd480aa486045$var$PCT,
    $f8cfd480aa486045$var$PCT
].join($f8cfd480aa486045$var$COMMA) + $f8cfd480aa486045$var$RE_S + '\\)$');
const $f8cfd480aa486045$var$RE_HSLA_LEGACY = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
const $f8cfd480aa486045$var$RE_LAB = new RegExp('^lab\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_LCH = new RegExp('^lch\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$ANLGE
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_OKLAB = new RegExp('^oklab\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_OKLCH = new RegExp('^oklch\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$ANLGE
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const { round: $f8cfd480aa486045$var$round } = Math;
const $f8cfd480aa486045$var$roundRGB = (rgb)=>{
    return rgb.map((v, i)=>i <= 2 ? (0, $gb2Ug.default)($f8cfd480aa486045$var$round(v), 0, 255) : v);
};
const $f8cfd480aa486045$var$percentToAbsolute = (pct, min = 0, max = 100, signed = false)=>{
    if (typeof pct === 'string' && pct.endsWith('%')) {
        pct = parseFloat(pct.substring(0, pct.length - 1)) / 100;
        if (signed) // signed percentages are in the range -100% to 100%
        pct = min + (pct + 1) * 0.5 * (max - min);
        else pct = min + pct * (max - min);
    }
    return +pct;
};
const $f8cfd480aa486045$var$noneToValue = (v, noneValue)=>{
    return v === 'none' ? noneValue : v;
};
const $f8cfd480aa486045$var$css2rgb = (css)=>{
    css = css.toLowerCase().trim();
    if (css === 'transparent') return [
        0,
        0,
        0,
        0
    ];
    let m;
    if ((0, $lT4NS.default).format.named) try {
        return (0, $lT4NS.default).format.named(css);
    // eslint-disable-next-line
    } catch (e) {}
    // rgb(250 20 0) or rgb(250,20,0)
    if ((m = css.match($f8cfd480aa486045$var$RE_RGB)) || (m = css.match($f8cfd480aa486045$var$RE_RGB_LEGACY))) {
        let rgb = m.slice(1, 4);
        for(let i = 0; i < 3; i++)rgb[i] = +$f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(rgb[i], 0), 0, 255);
        rgb = $f8cfd480aa486045$var$roundRGB(rgb);
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha; // default alpha
        return rgb;
    }
    // rgba(250,20,0,0.4)
    if (m = css.match($f8cfd480aa486045$var$RE_RGBA_LEGACY)) {
        const rgb = m.slice(1, 5);
        for(let i = 0; i < 4; i++)rgb[i] = +$f8cfd480aa486045$var$percentToAbsolute(rgb[i], 0, 255);
        return rgb;
    }
    // hsl(0,100%,50%)
    if ((m = css.match($f8cfd480aa486045$var$RE_HSL)) || (m = css.match($f8cfd480aa486045$var$RE_HSL_LEGACY))) {
        const hsl = m.slice(1, 4);
        hsl[0] = +$f8cfd480aa486045$var$noneToValue(hsl[0].replace('deg', ''), 0);
        hsl[1] = +$f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(hsl[1], 0), 0, 100) * 0.01;
        hsl[2] = +$f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(hsl[2], 0), 0, 100) * 0.01;
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $7PGtI.default)(hsl));
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    // hsla(0,100%,50%,0.5)
    if (m = css.match($f8cfd480aa486045$var$RE_HSLA_LEGACY)) {
        const hsl = m.slice(1, 4);
        hsl[1] *= 0.01;
        hsl[2] *= 0.01;
        const rgb = (0, $7PGtI.default)(hsl);
        for(let i = 0; i < 3; i++)rgb[i] = $f8cfd480aa486045$var$round(rgb[i]);
        rgb[3] = +m[4]; // default alpha = 1
        return rgb;
    }
    if (m = css.match($f8cfd480aa486045$var$RE_LAB)) {
        const lab = m.slice(1, 4);
        lab[0] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(lab[0], 0), 0, 100);
        lab[1] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(lab[1], 0), -125, 125, true);
        lab[2] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(lab[2], 0), -125, 125, true);
        // convert to D50 Lab whitepoint
        const wp = (0, $8weUB.getLabWhitePoint)();
        (0, $8weUB.setLabWhitePoint)('d50');
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $jenZn.default)(lab));
        // convert back to original Lab whitepoint
        (0, $8weUB.setLabWhitePoint)(wp);
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($f8cfd480aa486045$var$RE_LCH)) {
        const lch = m.slice(1, 4);
        lch[0] = $f8cfd480aa486045$var$percentToAbsolute(lch[0], 0, 100);
        lch[1] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(lch[1], 0), 0, 150, false);
        lch[2] = +$f8cfd480aa486045$var$noneToValue(lch[2].replace('deg', ''), 0);
        // convert to D50 Lab whitepoint
        const wp = (0, $8weUB.getLabWhitePoint)();
        (0, $8weUB.setLabWhitePoint)('d50');
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $g4jd5.default)(lch));
        // convert back to original Lab whitepoint
        (0, $8weUB.setLabWhitePoint)(wp);
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($f8cfd480aa486045$var$RE_OKLAB)) {
        const oklab = m.slice(1, 4);
        oklab[0] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklab[0], 0), 0, 1);
        oklab[1] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklab[1], 0), -0.4, 0.4, true);
        oklab[2] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklab[2], 0), -0.4, 0.4, true);
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $5D4bx.default)(oklab));
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($f8cfd480aa486045$var$RE_OKLCH)) {
        const oklch = m.slice(1, 4);
        oklch[0] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklch[0], 0), 0, 1);
        oklch[1] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklch[1], 0), 0, 0.4, false);
        oklch[2] = +$f8cfd480aa486045$var$noneToValue(oklch[2].replace('deg', ''), 0);
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $9cCPH.default)(oklch));
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
};
$f8cfd480aa486045$var$css2rgb.test = (s)=>{
    return(// modern
    $f8cfd480aa486045$var$RE_RGB.test(s) || $f8cfd480aa486045$var$RE_HSL.test(s) || $f8cfd480aa486045$var$RE_LAB.test(s) || $f8cfd480aa486045$var$RE_LCH.test(s) || $f8cfd480aa486045$var$RE_OKLAB.test(s) || $f8cfd480aa486045$var$RE_OKLCH.test(s) || // legacy
    $f8cfd480aa486045$var$RE_RGB_LEGACY.test(s) || $f8cfd480aa486045$var$RE_RGBA_LEGACY.test(s) || $f8cfd480aa486045$var$RE_HSL_LEGACY.test(s) || $f8cfd480aa486045$var$RE_HSLA_LEGACY.test(s) || s === 'transparent');
};
var $f8cfd480aa486045$export$2e2bcd8739ae039 = $f8cfd480aa486045$var$css2rgb;

});
parcelRegister("9cCPH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b335b6c71084560$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $d6n2X = parcelRequire("d6n2X");

var $5D4bx = parcelRequire("5D4bx");
const $6b335b6c71084560$var$oklch2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'lch');
    const [l, c, h, ...rest] = args;
    const [L, a, b_] = (0, $d6n2X.default)(l, c, h);
    const [r, g, b] = (0, $5D4bx.default)(L, a, b_);
    return [
        r,
        g,
        b,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $6b335b6c71084560$export$2e2bcd8739ae039 = $6b335b6c71084560$var$oklch2rgb;

});



parcelRegister("kBR14", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $gaK1V = parcelRequire("gaK1V");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
(0, $lT4NS.default).format.gl = (...args)=>{
    const rgb = (0, $43ZPL.default)(args, 'rgba');
    rgb[0] *= 255;
    rgb[1] *= 255;
    rgb[2] *= 255;
    return rgb;
};
const $f010634c2ba757fa$export$5822a9d0880a5d82 = (...args)=>new (0, $e7KSJ.default)(...args, 'gl');
(0, $gaK1V.default).gl = $f010634c2ba757fa$export$5822a9d0880a5d82;
(0, $e7KSJ.default).prototype.gl = function() {
    const rgb = this._rgb;
    return [
        rgb[0] / 255,
        rgb[1] / 255,
        rgb[2] / 255,
        rgb[3]
    ];
};

});

parcelRegister("bmZFS", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $gaK1V = parcelRequire("gaK1V");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $lT4NS = parcelRequire("lT4NS");

var $2BpKe = parcelRequire("2BpKe");

var $eL95G = parcelRequire("eL95G");
(0, $e7KSJ.default).prototype.hex = function(mode) {
    return (0, $eL95G.default)(this._rgb, mode);
};
const $84719710001139ea$export$834dfc94dde4b3d8 = (...args)=>new (0, $e7KSJ.default)(...args, 'hex');
(0, $gaK1V.default).hex = $84719710001139ea$export$834dfc94dde4b3d8;
(0, $lT4NS.default).format.hex = (0, $2BpKe.default);
(0, $lT4NS.default).autodetect.push({
    p: 4,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $hMEmV.default)(h) === 'string' && [
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ].indexOf(h.length) >= 0) return 'hex';
    }
});

});

parcelRegister("i89Hq", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $4vyUC = parcelRequire("4vyUC");

var $1X2Gd = parcelRequire("1X2Gd");
(0, $e7KSJ.default).prototype.temp = (0, $e7KSJ.default).prototype.kelvin = (0, $e7KSJ.default).prototype.temperature = function() {
    return (0, $1X2Gd.default)(this._rgb);
};
const $d3307f7157ff91e7$export$8d72b093afd1813e = (...args)=>new (0, $e7KSJ.default)(...args, 'temp');
Object.assign((0, $gaK1V.default), {
    temp: $d3307f7157ff91e7$export$8d72b093afd1813e,
    kelvin: $d3307f7157ff91e7$export$8d72b093afd1813e,
    temperature: $d3307f7157ff91e7$export$8d72b093afd1813e
});
(0, $lT4NS.default).format.temp = (0, $lT4NS.default).format.kelvin = (0, $lT4NS.default).format.temperature = (0, $4vyUC.default);

});
parcelRegister("4vyUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $34852385cec165f3$export$2e2bcd8739ae039);
/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 */ const { log: $34852385cec165f3$var$log } = Math;
const $34852385cec165f3$var$temperature2rgb = (kelvin)=>{
    const temp = kelvin / 100;
    let r, g, b;
    if (temp < 66) {
        r = 255;
        g = temp < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * $34852385cec165f3$var$log(g);
        b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * $34852385cec165f3$var$log(b);
    } else {
        r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * $34852385cec165f3$var$log(r);
        g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * $34852385cec165f3$var$log(g);
        b = 255;
    }
    return [
        r,
        g,
        b,
        1
    ];
};
var $34852385cec165f3$export$2e2bcd8739ae039 = $34852385cec165f3$var$temperature2rgb;

});

parcelRegister("1X2Gd", function(module, exports) {

$parcel$export(module.exports, "default", () => $16bd614d337f08eb$export$2e2bcd8739ae039);
/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 **/ 
var $4vyUC = parcelRequire("4vyUC");
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { round: $16bd614d337f08eb$var$round } = Math;
const $16bd614d337f08eb$var$rgb2temperature = (...args)=>{
    const rgb = (0, $43ZPL.default)(args, 'rgb');
    const r = rgb[0], b = rgb[2];
    let minTemp = 1000;
    let maxTemp = 40000;
    const eps = 0.4;
    let temp;
    while(maxTemp - minTemp > eps){
        temp = (maxTemp + minTemp) * 0.5;
        const rgb = (0, $4vyUC.default)(temp);
        if (rgb[2] / rgb[0] >= b / r) maxTemp = temp;
        else minTemp = temp;
    }
    return $16bd614d337f08eb$var$round(temp);
};
var $16bd614d337f08eb$export$2e2bcd8739ae039 = $16bd614d337f08eb$var$rgb2temperature;

});


parcelRegister("35MHU", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $9cCPH = parcelRequire("9cCPH");

var $855Nw = parcelRequire("855Nw");
(0, $e7KSJ.default).prototype.oklch = function() {
    return (0, $855Nw.default)(this._rgb);
};
const $24079ef8e8403722$export$c21b932a666e3753 = (...args)=>new (0, $e7KSJ.default)(...args, 'oklch');
Object.assign((0, $gaK1V.default), {
    oklch: $24079ef8e8403722$export$c21b932a666e3753
});
(0, $lT4NS.default).format.oklch = (0, $9cCPH.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'oklch');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'oklch';
    }
});

});



parcelRegister("ceOOn", function(module, exports) {

$parcel$export(module.exports, "getAllCookies", () => $8e8e34fa89bb9263$export$1191989ae3ee4c15);
const $8e8e34fa89bb9263$export$1191989ae3ee4c15 = ()=>{
    const cookies = document.cookie.split('; ');
    const allCookies = [];
    cookies.forEach((cookie)=>{
        const cookieParts = cookie.split('=');
        allCookies[cookieParts[0]] = cookieParts[1];
    });
    return allCookies;
};

});

parcelRegister("a3TA1", function(module, exports) {

$parcel$export(module.exports, "elementReady", () => $75354c334d353ce6$export$5a68694636710d38);
const $75354c334d353ce6$export$5a68694636710d38 = (selector)=>new Promise((resolve)=>{
        const el = document.querySelectorAll(selector);
        if (el.length) {
            resolve(el);
            return;
        }
        new MutationObserver(()=>{
            // Query for elements matching the specified selector
            Array.from(document.querySelectorAll(selector)).forEach((element)=>{
                resolve(element);
            });
        }).observe(document.documentElement, {
            childList: true,
            subtree: true
        });
    });

});

parcelRegister("6oLIz", function(module, exports) {

$parcel$export(module.exports, "addWindowResizeEvent", () => $4a89ffbcc8257418$export$5f2cd73bfe4df536);
$parcel$export(module.exports, "addWindowScrollEvent", () => $4a89ffbcc8257418$export$b502183889628ce0);
const $4a89ffbcc8257418$export$5f2cd73bfe4df536 = (callback)=>{
    let timeout;
    window.addEventListener('resize', ()=>{
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};
const $4a89ffbcc8257418$export$b502183889628ce0 = (callback)=>{
    let timeout;
    window.addEventListener('scroll', ()=>{
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};

});

parcelRegister("isKkJ", function(module, exports) {

$parcel$export(module.exports, "getReCAPTCHAResponse", () => $d70ec861cf7f176b$export$26ae508a4c7ca84d);

var $6sEQA = parcelRequire("6sEQA");
const $d70ec861cf7f176b$export$26ae508a4c7ca84d = async (action)=>{
    try {
        const themeData = await (0, $6sEQA.getThemeData)();
        if (!themeData.recaptcha_site_key) throw new Error('Missing Google reCAPTCHA Site Key in theme configuration');
        if (!themeData.ajax_actions?.recaptcha_verify) throw new Error('Missing AJAX route to verify reCAPTCHA token');
        if (!themeData.ajax_route) throw new Error('Missing global AJAX route');
        return new Promise((resolve, reject)=>{
            if (window.grecaptcha === undefined) {
                console.warn('Google reCAPTCHA is not loaded');
                resolve({
                    success: true,
                    score: 1
                });
            } else grecaptcha.ready(function() {
                grecaptcha.execute(themeData.recaptcha_site_key, {
                    action: action
                }).then(async function(token) {
                    const formData = new FormData();
                    formData.append('action', themeData.ajax_actions.recaptcha_verify);
                    // Determine if request is just a test
                    const testParam = 'e2e-test';
                    const url = new URL(window.location);
                    if (url.searchParams.has(testParam)) token = 'e2e-test-valid-user';
                    // Set reCATPCHA token
                    formData.append('recaptcha_token', token);
                    try {
                        const response = await fetch(themeData.ajax_route, {
                            method: 'POST',
                            body: formData
                        });
                        const json = await response.json();
                        if (json.success) resolve(json);
                        else if (json['error-codes']) {
                            /**
								 * reCATPCHA verification error codes
								 * @link https://developers.google.com/recaptcha/docs/verify#error_code_reference
								 *
								 * missing-input-secret	  The secret parameter is missing.
								 * invalid-input-secret	  The secret parameter is invalid or malformed.
								 * missing-input-response	The response parameter is missing.
								 * invalid-input-response	The response parameter is invalid or malformed.
								 * bad-request	          The request is invalid or malformed.
								 * timeout-or-duplicate	  The response is no longer valid: either is too old or has been used previously.
								 */ let errorMessages = [];
                            json['error-codes'].forEach((errorCode)=>{
                                switch(errorCode){
                                    case 'missing-input-secret':
                                        errorMessages.push('The secret parameter is missing.');
                                        break;
                                    case 'invalid-input-secret':
                                        errorMessages.push('The secret parameter is invalid or malformed.');
                                        break;
                                    case 'missing-input-response':
                                        errorMessages.push('The response parameter is missing.');
                                        break;
                                    case 'invalid-input-response':
                                        errorMessages.push('The response parameter is invalid or malformed.');
                                        break;
                                    case 'bad-request':
                                        errorMessages.push('The request is invalid or malformed.');
                                        break;
                                    case 'timeout-or-duplicate':
                                        errorMessages.push('The response is no longer valid: either is too old or has been used previously.');
                                        break;
                                    default:
                                        errorMessages.push('Unknown reCATPCHA error code');
                                }
                            });
                            throw new Error(`There was an error when trying to verify the user's response by reCATPCHA:\n${errorMessages.join('\n')}`);
                        } else if (json.data) throw new Error(`The request to verify the reCAPTCHA user token failed: ${response.data}`);
                        else throw new Error('Unknown error occurred when trying to verify the reCATPCHA user token');
                    } catch (e) {
                        reject(e);
                    }
                });
            });
        });
    } catch (e) {
        console.error(e);
    }
};

});
parcelRegister("6sEQA", function(module, exports) {

$parcel$export(module.exports, "getThemeData", () => $4b450af9f6d18c72$export$3c72f11fd9e5031f);
const $4b450af9f6d18c72$export$3c72f11fd9e5031f = ()=>{
    if (!window.themeDataRestUrl) throw new Error('Missing themeDataRestUrl in global context');
    else {
        const sessionStorageKey = 'themeData';
        return new Promise((resolve, reject)=>{
            if (sessionStorage.getItem('themeData')) resolve(JSON.parse(sessionStorage.getItem(sessionStorageKey)));
            else fetch(window.themeDataRestUrl).then((res)=>res.json()).then((data)=>{
                try {
                    sessionStorage.setItem(sessionStorageKey, JSON.stringify(data));
                } catch (e) {
                    console.warn(e);
                }
                resolve(data);
            }).catch((e)=>reject(e));
        });
    }
};

});


parcelRegister("h30hJ", function(module, exports) {

$parcel$export(module.exports, "slideUp", () => $c692f0128d3d0bc1$export$deed561b1a0ff1ea);
$parcel$export(module.exports, "slideDown", () => $c692f0128d3d0bc1$export$abdd11a06a163232);
const $c692f0128d3d0bc1$export$deed561b1a0ff1ea = (target, duration = 500)=>{
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    [
        'height',
        'paddingTop',
        'paddingBottom',
        'marginTop',
        'marginBottom'
    ].forEach((prop)=>{
        target.style[prop] = 0;
    });
    window.setTimeout(()=>{
        target.style.display = 'none';
        [
            'height',
            'padding-top',
            'padding-bottom',
            'margin-top',
            'margin-bottom',
            'overflow',
            'transition-duration',
            'transition-property'
        ].forEach((prop)=>target.style.removeProperty(prop));
    }, duration);
};
const $c692f0128d3d0bc1$export$abdd11a06a163232 = (target, duration = 500)=>{
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    display === 'none' && (display = 'block');
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    [
        'height',
        'paddingTop',
        'paddingBottom',
        'marginTop',
        'marginBottom'
    ].forEach((prop)=>{
        target.style[prop] = 0;
    });
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    [
        'padding-top',
        'padding-bottom',
        'margin-top',
        'margin-bottom'
    ].forEach((prop)=>target.style.removeProperty(prop));
    window.setTimeout(()=>{
        [
            'height',
            'overflow',
            'transition-duration',
            'transition-property'
        ].forEach((prop)=>target.style.removeProperty(prop));
    }, duration);
};
const $c692f0128d3d0bc1$export$715de50cedc228a8 = (target, duration = 500)=>window.getComputedStyle(target).display === 'none' ? $c692f0128d3d0bc1$export$abdd11a06a163232(target, duration) : $c692f0128d3d0bc1$export$deed561b1a0ff1ea(target, duration);

});

parcelRegister("jWfAU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83f87d19c5951a4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "scrollToElement", () => $e83f87d19c5951a4$export$2353115f31f4d15);
var $e83f87d19c5951a4$export$2e2bcd8739ae039 = ()=>{
    // ! Important: Wait until page has fully loaded before scrolling (#Chrome bug)
    window.addEventListener('load', ()=>{
        if (window.location.hash) {
            window.scrollTo(0, 0);
            setTimeout(()=>{
                $e83f87d19c5951a4$export$2353115f31f4d15(window.location.hash);
            }, 1);
        }
    });
    document.addEventListener('click', function(e) {
        // loop parent nodes from the target to the delegation node
        for(let target = e.target; target && target != this; target = target.parentNode)if (target.matches('a[href^="#"]:not([href="#"]):not([href="#/"]):not(._brlbs-btn)')) {
            e.preventDefault();
            $e83f87d19c5951a4$export$2353115f31f4d15(target.getAttribute('href'));
            break;
        }
    }, false);
};
const $e83f87d19c5951a4$export$2353115f31f4d15 = (selector)=>{
    const targetEl = document.querySelector(selector);
    if (!targetEl) return;
    // Set initial scroll to an offset to increase headroom
    let scrollOffset = 32;
    // Add header height to offset if necessary
    const headerBar = document.querySelector('header.nav');
    scrollOffset += headerBar?.getBoundingClientRect().height || 0;
    // Add height of WP admin bar for logged in users
    if (document.querySelector('#wpadminbar')) scrollOffset += document.querySelector('#wpadminbar').getBoundingClientRect().height;
    // Start scrolling
    window.scrollTo(0, window.scrollY + targetEl.getBoundingClientRect().top - scrollOffset);
};

});

parcelRegister("hxRak", function(module, exports) {

$parcel$export(module.exports, "waitForElement", () => $cc5ec25473bb8d84$export$1a1c301579a08d1e);
const $cc5ec25473bb8d84$export$1a1c301579a08d1e = (selector)=>{
    return new Promise((resolve)=>{
        if (document.querySelector(selector)) return resolve(document.querySelector(selector));
        const observer = new MutationObserver(()=>{
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
};

});


parcelRegister("i400O", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $d2689c1b6ccbb1f5$export$ac4959f4f1338dfc);
/* @ts-self-types="./index.d.ts" */ let $d2689c1b6ccbb1f5$var$urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let $d2689c1b6ccbb1f5$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = '';
        let i = size | 0;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $d2689c1b6ccbb1f5$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let i = size | 0;
    while(i--)id += $d2689c1b6ccbb1f5$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};

});

var $29bdd7704a516897$export$2e2bcd8739ae039 = ()=>{
    const checkbox = 'input[type="checkbox"]';
    const classBefore = 'before';
    const classAfter = 'after';
    // Switches
    const setCheckedClass = (wrapper)=>{
        const classList = wrapper.classList;
        if (wrapper.querySelector(checkbox).checked) {
            classList.contains(classBefore) && classList.remove(classBefore);
            classList.add(classAfter);
        } else {
            classList.contains(classAfter) && classList.remove(classAfter);
            classList.add(classBefore);
        }
    };
    document.querySelectorAll('.custom-switch-wrapper').forEach((elem)=>{
        setCheckedClass(elem);
        // Add listener
        elem.querySelector(checkbox).addEventListener('change', ()=>{
            setCheckedClass(elem);
        });
    });
};


const $72e23d5bf69340aa$var$scriptsQueue = [];
const $72e23d5bf69340aa$export$6c7bf672a565b827 = (selector, scriptSource, threshold = 0)=>{
    const loadScript = (src)=>{
        // ! Only continue if script wasn't already loaded previously
        if (!$72e23d5bf69340aa$var$scriptsQueue.includes(src)) {
            const scriptTag = document.createElement('script');
            scriptTag.src = src;
            document.querySelector('body').appendChild(scriptTag);
            $72e23d5bf69340aa$var$scriptsQueue.push(src);
        }
    };
    const elements = document.querySelectorAll(selector);
    if (elements.length) {
        // * Initialize IntersectionObserver
        const observer = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    if (Array.isArray(scriptSource)) scriptSource.forEach((src)=>loadScript(src));
                    else loadScript(scriptSource);
                    // ! Disconnect observer to avoid loading the script again and again when another element is intersecting
                    observer.disconnect();
                    // Remove data attribute since we don't need it any longer
                    elements.forEach((el)=>el.removeAttribute('data-script-dependencies'));
                }
            });
        }, {
            threshold: threshold
        });
        // * Observe elements
        elements.forEach((el)=>observer.observe(el));
    }
};


parcelRequire("kOgzt");
var $3IaSv = parcelRequire("3IaSv");
const $b21ff78dc05a364a$var$degToRad = (degrees)=>Math.PI / 180 * degrees;
const $b21ff78dc05a364a$var$getOrbitColors = (canvas)=>{
    const colors = {
        orbit: (0, $3IaSv.getColorHexValue)('primary', 0.1),
        satellite: (0, $3IaSv.getColorHexValue)('secondary')
    };
    if (canvas.classList.contains('orbit--highlight')) {
        colors.orbit = (0, $3IaSv.getColorHexValue)('body', 0.1, true);
        colors.satellite = (0, $3IaSv.getColorHexValue)('secondary');
    } else if (canvas.classList.contains('orbit--alternative-colors')) {
        colors.orbit = (0, $3IaSv.getColorHexValue)('primary', 0.2);
        colors.satellite = (0, $3IaSv.getColorHexValue)('primary');
    }
    return colors;
};
const $b21ff78dc05a364a$var$initCanvasElements = ()=>{
    document.querySelectorAll('canvas.orbit').forEach((canvas)=>{
        if (canvas.classList.contains('orbit--reverse')) canvas.style.transform = 'rotate(180deg)';
        const colors = $b21ff78dc05a364a$var$getOrbitColors(canvas);
        const cv = canvas.getContext('2d');
        const settings = {
            satellite: {
                length: 150,
                scale: 2
            },
            view: {
                height: 300
            }
        };
        const orbitDimensions = {
            x: window.innerWidth / 2,
            y: window.innerWidth * settings.satellite.scale + settings.view.height / 3,
            size: window.innerWidth * settings.satellite.scale
        };
        canvas.width = document.querySelector('html').clientWidth;
        canvas.height = 300;
        const circleLength = orbitDimensions.size * 2 * Math.PI;
        const satDegreeLength = settings.satellite.length / circleLength * 360;
        const sineOfAngle = canvas.width / 2 / orbitDimensions.size;
        const angleInRadians = Math.asin(sineOfAngle);
        const angleInDegrees = angleInRadians * 180 / Math.PI;
        const draw = (progress)=>{
            // Background
            cv.fillStyle = 'transparent';
            cv.fillRect(0, 0, canvas.width, canvas.height);
            // Orbit
            cv.beginPath();
            cv.arc(orbitDimensions.x, orbitDimensions.y, orbitDimensions.size, $b21ff78dc05a364a$var$degToRad(0), $b21ff78dc05a364a$var$degToRad(360), true);
            cv.lineWidth = 2;
            cv.strokeStyle = colors.orbit;
            cv.stroke();
            // Satellite
            cv.beginPath();
            cv.arc(orbitDimensions.x, orbitDimensions.y, orbitDimensions.size, $b21ff78dc05a364a$var$degToRad(270 - angleInDegrees + progress), $b21ff78dc05a364a$var$degToRad(270 - (angleInDegrees + satDegreeLength) + progress), true);
            cv.lineWidth = 16;
            cv.lineCap = 'round';
            cv.strokeStyle = colors.satellite;
            cv.stroke();
        };
        let progress = 0;
        const animation = ()=>{
            cv.clearRect(0, 0, canvas.width, canvas.height);
            if (canvas.width >= 500) progress += canvas.width >= 1200 ? 0.025 : 0.05;
            else progress += 0.0875;
            if (progress > angleInDegrees * 2 + satDegreeLength) progress = 0;
            draw(progress);
            requestAnimationFrame(animation);
        };
        animation();
    });
};
window.addEventListener('DOMContentLoaded', $b21ff78dc05a364a$var$initCanvasElements);
window.addEventListener('resize', $b21ff78dc05a364a$var$initCanvasElements);
document.addEventListener('colorModeChange', $b21ff78dc05a364a$var$initCanvasElements);


// Polyfill for Element.prototype.checkVisibility
if (!Element.prototype.checkVisibility) Element.prototype.checkVisibility = function() {
    // Polyfill: checks if element is rendered (not display:none, not visibility:hidden, opacity > 0)
    const style = window.getComputedStyle(this);
    return style.display !== 'none' && style.visibility !== 'hidden' && parseFloat(style.opacity) > 0;
};
/**
 * Add a class to the first visible section in the main content area
 */ function $5fafd2647c56729b$var$setFirstVisibleSection() {
    const className = 'first-visible-section';
    const sections = document.querySelectorAll('main > section');
    sections.forEach((section)=>section.classList.remove(className));
    for (const section of sections)if (section.checkVisibility?.()) {
        section.classList.add(className);
        break;
    }
}
// Debounce utility
function $5fafd2647c56729b$var$debounce(fn, delay) {
    let timer = null;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(()=>fn.apply(this, args), delay);
    };
}
// Run on DOMContentLoaded and on resize (debounced)
document.addEventListener('DOMContentLoaded', $5fafd2647c56729b$var$setFirstVisibleSection);
window.addEventListener('resize', $5fafd2647c56729b$var$debounce($5fafd2647c56729b$var$setFirstVisibleSection, 100));


parcelRequire("kOgzt");
var $a3TA1 = parcelRequire("a3TA1");

var $i400O = parcelRequire("i400O");
window.dataLayer = window.dataLayer || [];
const $b88a7969b7d4f230$var$marker = [
    10,
    25,
    50,
    75,
    90,
    100
];
const $b88a7969b7d4f230$var$timeStamps = new Array();
const $b88a7969b7d4f230$var$pushVideoTag = (event)=>{
    const t = event.target;
    const percentage = Math.floor(t.currentTime / t.duration * 100);
    const length = Math.floor(t.duration);
    const seconds = Math.floor(t.currentTime);
    // Send progress updates to GTM only when certain ranges are reached.
    for(let i = $b88a7969b7d4f230$var$marker.length - 1; i >= 0; i--){
        const m = $b88a7969b7d4f230$var$marker[i];
        if (percentage >= m) {
            if (!$b88a7969b7d4f230$var$timeStamps[t.id].includes(m)) {
                $b88a7969b7d4f230$var$timeStamps[t.id].push(m);
                const attributes = {
                    event: 'videoInternalProgress',
                    video: {
                        source: t.currentSrc,
                        length: length,
                        progress: {
                            percent: m,
                            seconds: seconds
                        }
                    }
                };
                if (t.dataset?.video) attributes.name = t.dataset.video;
                window.dataLayer.push(attributes);
            }
            break;
        }
    }
};
const $b88a7969b7d4f230$var$init = (video)=>{
    if (!video.id) video.id = 'video-' + (0, $i400O.nanoid)();
    $b88a7969b7d4f230$var$timeStamps[video.id] = new Array();
    video.addEventListener('timeupdate', $b88a7969b7d4f230$var$pushVideoTag);
};
(0, $a3TA1.elementReady)('video').then((video)=>{
    if (video instanceof NodeList) video.forEach((v)=>{
        $b88a7969b7d4f230$var$init(v);
    });
    else $b88a7969b7d4f230$var$init(video);
});



var $jWfAU = parcelRequire("jWfAU");

var $hxRak = parcelRequire("hxRak");
// Load scripts dynamically
window.addEventListener('load', ()=>{
    document.querySelectorAll('[data-script-dependencies]').forEach((el)=>{
        const dataValue = el.getAttribute('data-script-dependencies');
        const dependencies = dataValue.split(',');
        (0, $72e23d5bf69340aa$export$6c7bf672a565b827)(`[data-script-dependencies="${dataValue}"]`, dependencies);
    });
});
(0, $29bdd7704a516897$export$2e2bcd8739ae039)();
(0, $jWfAU.default)();
/**
 * Search on 404 pages
 *
 * Transforms the URL path to a string that can be used in the search.
 */ (()=>{
    if (document.querySelector('body').classList.contains('error404')) (0, $hxRak.waitForElement)('main .site-search input[type="text"]').then((searchInputField)=>{
        const url = new URL(window.location);
        if (url.pathname && url.pathname.length > 2) {
            const searchString = url.pathname.replace(/\/de\/|\/en\//, '') // Replace
            .replaceAll('-', ' ').replaceAll('/', ' ').trim();
            searchInputField.value = searchString;
            searchInputField.dispatchEvent(new Event('input'));
        }
    });
})();

})();
//# sourceMappingURL=main.min.js.map
